import { ChangeDetectorRef, Component, inject, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CountriesService } from 'src/app/countries.service';
import BusinessEntity from '../../../../services/businessEntity.model';
import { BusinessEntityService } from 'src/app/services/businessEntity.service';
import CreditsManagersModel, {
  DeviceDetails,
  SubscriberPaymentDetails,
  SubscriberPolicyDetails,
  SubscriberSubscriptionDuration,
  businessDetails
} from 'src/app/services/creditsManagers.model';
import { CreditsManagersService } from 'src/app/services/creditsManagers.service';
import CreditsPolicyModel from 'src/app/services/creditsPolicy.model';
import { CreditsPolicyService } from 'src/app/services/creditsPolicy.service';
import PersonsModel from 'src/app/services/persons.model';
import { PersonsService } from 'src/app/services/persons.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { CreditsUsageTrackerService } from 'src/app/services/creditUsageTracker.service';
import CreditUsageTrackerModel from 'src/app/services/creditUsageTracker.model';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { BatchLoader } from 'src/app/Utils/batch-loader.util';
import FarmSiteModel from "../../../../services/farmSite.model";
import { FarmSiteService } from "../../../../services/farmSite.service";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

/**
 * Component Represents for managing Subscribers data.
 * This component provides functionality to handle Susbcribers, display them in a list,
 * and interact with their data through forms and UI elements for creating and updating a new and existing Susbcriber.
 * @module SubscriptionsComponent
 */

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent {
// data display related variables i.e business contacts
  public subscribersList: any[] = [];
  public businessContacts = [];
  public priorityBusinessContacts = [];
  public bluEyeSubscribers = [];
  public filteredBusinessContacts = [];
  public filteredBluEyeSubscribers = [];
  public creditPoliciesList = [];
  public status!: string;
  public farmSites!: Array<FarmSiteModel>
  public subscriberUsageTrackerView!: Array<CreditUsageTrackerModel>;
  public businessContactsTrackerView!: Array<CreditUsageTrackerModel>;
  public whatsappMessageSubscribersTrackerView: any;
  public BlueEyeSubscribersTrackerView: any;
  public filteredSubscriberUsageTrackerViews = [];
  public filteredBlueEyeSubscribersTrackerView = [];
  public businessContactViewTabActive: boolean = false;
  public bluEyePolicyViewTabActive: boolean = false;
  public creditManager: CreditsManagersModel;
  public subscriberSubscriptionsDuration: SubscriberSubscriptionDuration;
  public subscriberPolicyDetails: SubscriberPolicyDetails;
  public subscriberPaymentDetails: SubscriberPaymentDetails;
  public businessDetails: businessDetails;
  public creditPolicy: CreditsPolicyModel;
  public businessEntity: BusinessEntity;
  public personEntity: any;
  public policyNamesList = [];
  public filteredCreditPoliciesList = [];
  public countriesList = [];
  public paymentOptions = [];

  //
  public policyTypeName: string;
  public policyId: string;
  public selectedPaidForCountryName: string;
  public selectedPaidByCountryName: string
  public selectedPaidForCountryObj: any;
  public selectedPaidByCountryObj: any;
  public paidForMobileNumber: string;
  public paidForMinimunNumber: string;
  public paidForMaximumNumber: string;
  public paidByMinimunNumber: string;
  public paidByMaximumNumber: string;
  public personName: string;
  public businessName: string;
  public paidByMobileNumber: string;
  public paidAmount: string;
  public selectedPaymentMode: string;
  public referenceID: string;
  public amountPaidDate: any;
  public countryCurrency: string;
  public termsAccepted: boolean;

  // Sorting filter variables
  public isPopupOpen: boolean;
  public popupLoader: boolean;
  public sortCreditsIssued: boolean;
  public sortCreditsused: boolean;
  public sortDurationleftDays: boolean;
  public prioritySortCreditsIssued: boolean;
  public prioritySortCreditsused: boolean;
  public prioritiesIssued: boolean;
  public prioritiesUsed: boolean;
  public prioritySortDurationleftDays: boolean;

  // Pagination Related variables
  public businessContactsCurrentPageNum = 1;
  public businessContactsNoofItemsPerPage = 6;
  public bluEyeSubscribersCurrentPageNum = 1;
  public bluEyeSubscribersNoofItemsPerPage = 6;

  // Conditional Based Blocks Displaying
  public isBusinessContactsTabActive: boolean = false;
  public isBluEyeSubscribersTabActive: boolean = false;

  // Filters Related variables
  public search: string = '';
  public usageTrackersearch: string = '';
  public statusFilter: boolean;

  // Credits Usage Tracker pagination variables
  public trackerOffset: number = 0;
  public readonly trackerPageSize: number = 20;
  public isTrackerLoading: boolean = false;
  public isTrackerEndOfData: boolean = false;
  public trackerListLoader: boolean = false;
  public currentTrackerSubscriberId: string = '';
  private trackerScrollTimeout: any;

  // On Page Load loader Related variables
  public responseLoader: boolean;

  // Form action buttons Related variables
  public submitButton: boolean = true;
  public updateButton: boolean;
  public enableDisableSubmitButton: boolean;
  public submitted: boolean;

  public bluEyePolicyObject: any;
  public backupBluEyePolicyObject: CreditsManagersModel;
  public deviceSaveState: { message: string; isSaved: boolean }[] = [];
  public isPolicyAccepted: boolean = false;
  // Declaring the stage form variable for form validation
  public registerForm: FormGroup;
  public formBuilder = inject(FormBuilder);

  // Dependency Injection Services
  public creditsPolicyService = inject(CreditsPolicyService);
  public creditsManagersService = inject(CreditsManagersService);
  public countriesService = inject(CountriesService);
  public businessEntityService = inject(BusinessEntityService);
  public personsService = inject(PersonsService);
  public subscriberUsageTrackerService = inject(CreditsUsageTrackerService);
  public ToastrService = inject(ToastrService);
  startDate: any;
  endDate: any;

  public listLoader = false;              // Show listLoader spinner
  public isFiltering: boolean = false;
  public noList: boolean = false;
  private batchLoader: BatchLoader<any>;

  public formFieldCount: number = 0;
  public showForm: boolean = false;
  public showAssignDeassignForm: boolean = false;
  minDate = new Date();
  dateRangeForm!: FormGroup;
  selected: {startDate: moment.Moment, endDate: moment.Moment};

  /**
   * Constructor for initializing dependencies required by the class.
   * @constructor
   * @param cdr
   * @param sanitizer
   */
  constructor(public cdr: ChangeDetectorRef, public sanitizer: DomSanitizer, public farmSiteService: FarmSiteService, public toastr: ToastrService) {
    // Initialize an empty array for save state tracking
    this.deviceSaveState = [];

    /**
     * Initializing a credit policy, credit manager, SubscriberSubscriptionDuration, SubscriberPaymentDetails, BusinessEntity, PersonsModel and businessDetails model.
     */
    this.creditPolicy = new CreditsPolicyModel();
    this.creditManager = new CreditsManagersModel();
    this.subscriberSubscriptionsDuration = new SubscriberSubscriptionDuration();
    this.subscriberPaymentDetails = new SubscriberPaymentDetails();
    this.subscriberPolicyDetails = new SubscriberPolicyDetails();
    this.businessEntity = new BusinessEntity();
    this.personEntity = new PersonsModel();
    this.businessDetails = new businessDetails();
    this.bluEyePolicyObject = new CreditsManagersModel();

    /**
     * Initializing Subscriber form for validation.
     * This FormGroup represents the form controls for the Subscriber data.
     * @type {FormGroup}
     * @type {FormControl}
     */
    this.registerForm = this.formBuilder.group({
      creditPolicyType: ['', Validators.required],
      creditPolicyName: ['', Validators.required],
      paidForCountryName: ['', Validators.required],
      paidForMobileNumber: ['', Validators.required],
      paidByCountryName: ['', Validators.required],
      paidByMobileNumber: [null],
      dateRange: this.formBuilder.group({
        start: [''],
        end: ['']
      },
        { updateOn: 'blur' }
      ),
      paidAmount: ['', Validators.required],
      paymentMode: ['', Validators.required],
      referenceid: ['', [Validators.pattern('^[a-zA-Z0-9-/]*$'), Validators.maxLength(50)]],
      termsAccepted: [false, Validators.required]
    });

    // Calculate field count after form is built
    this.formFieldCount = Object.keys(this.registerForm.controls).length;
  }

  /**
   * @async
   * @method
   * @throws {Error} If there's an error during initialization.
   * @returns {Promise<void>} A Promise that resolves when the initialization is completed or rejects if an error occurs.
   * Description:
   * This method is automatically invoked when the component is initialized.
   * It handles the setup of various properties and services and fetching subscribers details by calling getAllCreditManagers method in the {@link creditsManagersService}
   */
  public async ngOnInit() {
    try {
      this.policyTypeName = '';
      this.policyId = '';
      this.selectedPaidForCountryName = '';
      this.paidForMobileNumber = '';
      this.selectedPaidByCountryName = '';
      this.paidByMobileNumber = '';
      this.paidAmount = '';
      this.selectedPaymentMode = '';
      this.referenceID = '';
      this.responseLoader = true;
      this.enableDisableSubmitButton = false;
      this.displayPaymentOptions();
      window.scrollTo(0, 0);
      this.bluEyePolicyObject = undefined;
      this.amountPaidDate = (moment(new Date()).format('DD-MMM-YYYY')).toString();
      this.creditPoliciesList = (await this.creditsPolicyService.getAllCreditPolicies()).filter((policy: CreditsPolicyModel) => !['669a53233d6415787872a89c', '663f30ccf9f444ec1326f3cb'].includes(policy.id));
      this.countriesList = this.countriesService.ngOnInit().filter((country) => ['ES', 'ID', 'VN', 'NG', 'MY', 'AU', 'EC', 'SA', 'IN'].includes(country.isoCode));
      if (this.countriesList) {
        const indianCountryIndexPosition = this.countriesList.findIndex((country) => country.name == 'India');
        if (indianCountryIndexPosition != -1) {
          const objectToMove = this.countriesList.splice(indianCountryIndexPosition, 1);
          this.countriesList.unshift(objectToMove[0]);
          this.selectedPaidByCountryName = '+91';
          this.selectedPaidForCountryName = '+91';
          if (this.selectedPaidByCountryName) {
            this.paidBycountrySelected();
          }
          if (this.selectedPaidForCountryName) {
            this.paidForcountrySelected();
          }
        }
      }
      if (this.creditPoliciesList && this.creditPoliciesList.length > 0) {
        this.policyNamesList = Array.from(new Set(this.creditPoliciesList.map((data: any) => data['creditType']).filter((policyType: any) => policyType !== null))).map(value => ({
          ['policy_type_name']: value
        }));
      }
      this.setupFormSubscription();
      const allSubscribersList: any = await this.creditsManagersService.getAllCreditManagers();
      if (allSubscribersList && allSubscribersList.length > 0) {
        this.subscribersList = allSubscribersList.map((data) => {
          data.duration = data.durationLeft.period != null ? data.durationLeft.period : 0;
          data.businessType = data.businessID && data.businessID.businessType && data.businessID.businessType.length > 0 ? data.businessID.businessType[0].name : null;
          data.businessID = data.businessID ? data.businessID.id : '';
          return data;
        });
      }
      this.businessContacts = this.subscribersList.filter((businessSubcribers) => ['Trial', 'Premium'].includes(businessSubcribers.policyDetails?.name) && 
    businessSubcribers.businessType === 'External');
      this.bluEyeSubscribers = this.subscribersList.filter((businessSubcribers) => businessSubcribers.policyDetails?.name == 'BluEye Launch Plan' && 
    businessSubcribers.businessType === 'Farm');
      if (this.subscribersList && this.subscribersList.length > 0 && this.creditPoliciesList && this.creditPoliciesList.length > 0) {
        this.responseLoader = false;
      }
      this.switchPolicyTypeData('businessContacts');
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
      this.responseLoader = false;
    }
  }

  /**
   * @method
   * @returns {void} This function does not return a value.
   * Description:
   * This function establishes a subscription to form value changes and updates corresponding subscriber form properties accordingly.
   */
  public setupFormSubscription(): void {
    this.registerForm.valueChanges.subscribe(formValues => {
      this.policyTypeName = formValues.creditPolicyType;
      this.policyId = formValues.creditPolicyName;
      this.selectedPaidForCountryName = formValues.paidForCountryName;
      this.paidForMobileNumber = formValues.paidForMobileNumber;
      this.selectedPaidByCountryName = formValues.paidByCountryName;
      this.paidByMobileNumber = formValues.paidByMobileNumber;
      this.startDate = formValues.startdate;
      this.endDate = formValues.enddate;
      this.paidAmount = formValues.paidAmount;
      this.selectedPaymentMode = formValues.paymentMode;
      this.referenceID = formValues.referenceid;
    });
  }

  public initializedatePicker(): void {

  }

  /** runs when the Material picker closes */
  public onPickerClosed(): void {
    const dateRangeGroup = this.registerForm.get('dateRange') as FormGroup;
    const { start, end } = dateRangeGroup.value;

    if (start && !end) {
      // only start chosen → copy it to end
      dateRangeGroup.patchValue({ end: start }, { emitEvent: false });
      this.onDateChanged({ startDate: start, endDate: start });

    } else if (start && end) {
      this.onDateChanged({ startDate: start, endDate: end });
    }
  }

  /** keep the rest unchanged */
  public onDateChanged(range: { startDate: Date; endDate: Date }): void {
    this.selected = {
      startDate: moment(range.startDate),
      endDate: moment(range.endDate)
    };
  }

  public async switchPolicyTypeData(policyType: string) {
    this.search = '';
    this.statusFilter = false;
    this.status = undefined;
    switch (policyType) {
      case 'businessContacts':
        this.isBusinessContactsTabActive = true;
        this.isBluEyeSubscribersTabActive = false;
        break;
      default:
        this.isBluEyeSubscribersTabActive = true;
        this.isBusinessContactsTabActive = false;
        break;
    }
    this.initializeBatchLoader(); // Reset instance
    this.batchLoader.reset();     // Clear state
    await this.batchLoader.loadNextBatch(true); // Load first batch
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    this.checkScrollAndLoad();
  }

  private scrollTimeout: any;
  private checkScrollAndLoad(): void {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 &&
        !this.batchLoader?.isLoading() && !this.isFiltering) {
        this.batchLoader?.loadNextBatch();
      }
    }, 50);
  }

  private initializeBatchLoader(): void {
    this.batchLoader = new BatchLoader<any>(
      () => {
        switch (true) {
          case this.isBusinessContactsTabActive:
            return this.businessContacts;
          case this.isBluEyeSubscribersTabActive:
            return this.bluEyeSubscribers;
          default:
            return []; // fallback
        }
      },
      (updatedList) => {
        switch (true) {
          case this.isBusinessContactsTabActive:
            this.filteredBusinessContacts = updatedList;
            break;
          case this.isBluEyeSubscribersTabActive:
            this.filteredBluEyeSubscribers = updatedList;
            break;
        }
        this.noList = updatedList.length === 0;
      },
      undefined,
      (loading) => this.listLoader = loading
    );
  }

  public switchTrackerViewTabs(policyType: string) {
    this.usageTrackersearch = '';
    switch (policyType) {
      case 'businessContacts':
        this.businessContactViewTabActive = true;
        this.bluEyePolicyViewTabActive = false;
        this.filteredSubscriberUsageTrackerViews = this.businessContactsTrackerView;
        break;
      case 'BluEye':
        this.businessContactViewTabActive = false;
        this.bluEyePolicyViewTabActive = true;
        this.filteredBlueEyeSubscribersTrackerView = this.BlueEyeSubscribersTrackerView;
        break;
      default:
        break;
    }
  }

  /**
   * @method
   * Description:
   * This method will be called on component initialization to load payment options to display it in the subscriber form
   */
  public displayPaymentOptions() {
    this.paymentOptions = [
      {
        paymentName: 'GPay', isPaymentSelected: false, name: 'Shrimp', value: 'GPay'
      },
      {
        paymentName: 'Phonpe', isPaymentSelected: false, name: 'Fish', value: 'phonpe'
      },
      {
        paymentName: 'Paytm', isPaymentSelected: false, name: 'Nauplii', value: 'paytm'
      },
      {
        paymentName: 'IMPS', isPaymentSelected: false, name: 'Nauplii', value: 'imps'
      },
      {
        paymentName: 'NEFT', isPaymentSelected: false, name: 'Nauplii', value: 'neft'
      },
      {
        paymentName: 'RTGS', isPaymentSelected: false, name: 'Nauplii', value: 'rtgs'
      }
    ]
  }

  /**
   * @method
   * Description:
   * This method will be called when user toogles the payment options displayed in the subscriber form to update the selected payment mode.
   */
  public togglePaymentOption(paymentOption: any): void {
    this.paymentOptions.forEach(c => {
      if (c === paymentOption) {
        c.isPaymentSelected = true;
        this.selectedPaymentMode = c.value;
        this.registerForm.patchValue({
          paymentMode: this.selectedPaymentMode
        });
        this.registerForm.get('paymentMode')?.setValue(this.selectedPaymentMode);
      } else {
        c.isPaymentSelected = false;
      }
    });
    this.bluEyePolicyObject.paymentDetails.paymentMode = this.selectedPaymentMode
  }

  public openForm() {
    this.showForm = true;
    this.submitButton = true;
    this.updateButton = false;
    this.isPopupOpen = false;
    this.isPolicyAccepted = false;
    this.termsAccepted = false;
    this.registerForm.patchValue({ termsAccepted: false });

    // Count form fields to toggle layout
    this.formFieldCount = Object.keys(this.registerForm.controls).length;
  }

  /**
   * @method
   * Description:
   * This method will be called when user selects the policy type in the subscriber form to get the policies list based on the policy type selected to display the policies list
   * associated with the policy type selected.
   */
  public getCreditPoliciesByPolicyType() {
    this.filteredCreditPoliciesList = this.creditPoliciesList.filter((creditPolicy: CreditsPolicyModel) => creditPolicy.creditType == this.policyTypeName);
    if (this.submitButton) {
      this.policyId = undefined;
      this.creditPolicy = undefined;
      this.registerForm.patchValue({
        creditPolicyName: '',
      });
    }
  }

  /**
   * @method
   * Description:
   * This method will be called when user selects the policy in the subscriber form to assign the selected policy to our credit policy model.
   */
  public getCreditPolicy() {
    this.creditPolicy = this.creditPoliciesList.find(p => p.id === this.policyId);
    this.paidAmount = this.creditPolicy?.policyCost;
    this.registerForm.patchValue({
      paidAmount: this.paidAmount
    });

    const policyName = this.creditPolicy?.policyName || '';

    const dateRangeGroup = this.registerForm.get('dateRange');
    const startControl = dateRangeGroup?.get('start');
    const endControl = dateRangeGroup?.get('end');

    if (policyName === 'BluEye Launch Plan') {
      startControl?.setValidators([Validators.required]);
      endControl?.setValidators([Validators.required]);
    } else {
      startControl?.clearValidators();
      endControl?.clearValidators();
    }

    // Re-calculate validity after changing validators
    startControl?.updateValueAndValidity();
    endControl?.updateValueAndValidity();

    if (this.paidForMobileNumber && this.registerForm.get('paidForMobileNumber')?.valid) {
      this.getBusinessAndPersonDetails();
    }
  }

  /**
   * @method
   * Description:
   * This method will be called when on each number entered in the mobile number in paid for mobile number field and the purpose of this method is that i am validsating
   * the mobile number i.e mobile number exists or not, entered mobile number is associated with the selected country or not, entered mobile number is having an business or not,
   * entered mobile number person is of Hatchery or External business only or not.
   * mobile number validation check.
   */
  public async getBusinessAndPersonDetails() {
    try {
      if (!this.policyTypeName || !this.policyId || !this.creditPolicy?.policyName) {
        return; // Silent return: do not trigger warning toastr on keypresses before policy is selected
      }
      if (this.registerForm.get('paidForMobileNumber').valid && this.paidForMobileNumber.length <= Number(this.paidForMaximumNumber)) {
        switch (this.creditPolicy?.policyName) {
          case 'Premium':
            await this.handleSubscriptionValidation(['Exporter', 'Food Chain Owner', 'Middle Man', 'Retailer'], 'Business not found for that user unable to add subscriptions');
            break;

          case 'BluEye Launch Plan':
            await this.handleSubscriptionValidation(['Farmer'], 'Business not found for that user unable to add subscriptions');
            break;

          default:
            break;
        }
      }
    } catch (error) {
      console.log('error on getBusinessAndPersonDetails', error);
    }
  }

  /**
   * Validates mobile number and assigns business/person details
   * @param allowedRoles - list of person roles eligible for this subscription
   * @param businessNotFoundMessage - error message if business is not linked
   */
  private async handleSubscriptionValidation(allowedRoles: string[], businessNotFoundMessage: string) {
    this.deviceMessages = []; // Reset device messages on each validation attempt
    if (this.creditPolicy?.policyName == 'BluEye Launch Plan') {
      this.businessEntity = await this.businessEntityService.getBusinessByMobileNumber(this.paidForMobileNumber);
      this.isPolicyAccepted = false;
      // case: business not found
      if (!this.businessEntity) {
        return this.handleError(businessNotFoundMessage);
      }

      const businessType = this.businessEntity?.businessType?.[0]?.name;
      if (!['Farm'].includes(businessType)) {
        return this.handleError('Subscription is only applicable for Farm businesses');
      }

      // Success: Assign business and person details
      this.businessName = this.businessEntity.businessName;
      this.personName = null;
      this.termsAccepted = false;
      this.isPolicyAccepted = false;
      this.personEntity = [];

      this.registerForm.patchValue({
        termsAccepted: false,
      });

      this.bluEyePolicyObject = undefined;
      this.backupBluEyePolicyObject = undefined;
      this.activeIndex = null;
      this.bluEyePLanLogicBLock();
    } else {
      this.personEntity = await this.personsService.getPersonByMobileNumber(this.paidForMobileNumber);
      // Case: user not found
      if (!this.personEntity?.[0]) {
        return this.handleError('User not exist with that mobile number please try with valid number');
      }

      const person = this.personEntity[0] || null;
      const role = person?.personType?.[0]?.name;

      // Case: role not eligible
      if (!allowedRoles.includes(role)) {
        return this.handleError(`Subscription is only applicable for ${allowedRoles.join(' or ')} user`);
      }

      // Case: country code mismatch
      if (person.dialingCode !== this.selectedPaidForCountryName) {
        return this.handleError('Entered Mobile number is not associated with the selected country code');
      }

      // Case: no business assigned
      if (!person.businessID) {
        return this.handleError(businessNotFoundMessage);
      }

      // Success: Assign business and person details
      this.assignBusinessAndPerson(person);
    }
  }

  /**
   * Assigns business and person details when validation succeeds
   */
  private assignBusinessAndPerson(person: any) {
    this.businessEntity = person.businessID;
    this.businessName = person.businessID.businessName;
    this.personName = `${person.firstName} ${person.lastName}`;
    this.termsAccepted = false;
    this.isPolicyAccepted = false;
    this.registerForm.patchValue({
      termsAccepted: false,
    });
  }

  /**
   * Handles error cases: shows message, resets state & form
   * @param message - error message to show in toastr
   */
  private handleError(message: string) {
    this.toastr.error(message);
    this.resetFormState();
  }

  /**
   * Resets form state when validation fails
   */
  private resetFormState() {
    this.businessName = '';
    this.personName = '';
    this.termsAccepted = false;

    this.registerForm.patchValue({
      paidForMobileNumber: '',
      termsAccepted: false,
    });

    this.isPolicyAccepted = false;
    this.businessEntity = new BusinessEntity();
    this.personEntity = [];
    this.paidForMobileNumber = '';
  }

  alreadyPolicyObject: any;

  public bluEyePLanLogicBLock() {
    this.bluEyePolicyObject = undefined;
    const blueEyePolicy = this.bluEyeSubscribers.find(
      (subscriber) =>
        subscriber.policyDetails.policyFlag === 'BELP' &&
        this.businessEntity.id === subscriber.businessID
    );
    this.alreadyPolicyObject = blueEyePolicy;
    if (blueEyePolicy) {
      this.bluEyePolicyObject = JSON.parse(JSON.stringify(blueEyePolicy)); // 🔁 Deep copy
      this.initializeBackup();
    }
  }

  private initializeBackup() {
    if (this.bluEyePolicyObject) {
      this.registerForm.patchValue({
        paidAmount: this.bluEyePolicyObject.paymentDetails.amount
      });
      this.backupBluEyePolicyObject = JSON.parse(JSON.stringify(this.bluEyePolicyObject));
      // Initialize save state tracking for each device
      this.deviceSaveState = this.bluEyePolicyObject.devicesDetails.map(() => ({
        message: '',
        isSaved: false,
      }));
    }
  }

  public activeIndex: number | null = null;

  public toggleCard(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

  public isSubscribedDevicesAvailable(): boolean {
    const devices = this.bluEyePolicyObject?.devicesDetails || [];
    if (devices.length === 0) {
      return true; // If devices length is 0, return true
    }
    if (devices.length === 1) {
      return devices[0].isAdditionalDevice === true; // If only one device exists, check isAdditionalDevice
    }
    return false; // If more than 1 device exists, return false
  }

  public addCardToExistingDevicesList() {
    const newDeviceCost = 32448.82; // Cost of the new device being added
    // Ensure bluEyePolicyObject is initialized
    if (!this.bluEyePolicyObject) {
      this.bluEyePolicyObject = { devicesDetails: [], paymentDetails: { amount: 0 } };
    }
    // Ensure devicesDetails exists
    if (!this.bluEyePolicyObject.devicesDetails) {
      this.bluEyePolicyObject.devicesDetails = [];
    }
    // Ensure paymentDetails exists
    if (!this.bluEyePolicyObject.paymentDetails) {
      this.bluEyePolicyObject.paymentDetails = { amount: 0 };
    }
    let userLicense: any[];
    if (this.businessEntity?.businessType?.[0].name == 'Farm') {
      userLicense = [
        {
          roleID: '61712f64e37ea5001eb52ab6',
          roleName: 'Farmer',
          noOfLicenses: 1,
          cost: 999,
          gstPercent: null,
          gstCost: null,
          isDefault: true
        },
        {
          roleID: '61712f8ce37ea5001eb52ab7',
          roleName: 'Farm Manager',
          noOfLicenses: 1,
          cost: 999,
          gstPercent: null,
          gstCost: null,
          isDefault: true
        }]
    }
    const emptyDevice: any = {
      deviceConfiguationID: this.creditPolicy?.devices?.[0]._id,
      deviceNumber: '',
      prodUnitId: null,
      prodUnitName: null,
      bluePod: { id: '', name: null, cost: 9999, gstPercent: null, gstCost: null },
      bluEye: {
        cost: 17500, gstPercent: null, gstCost: null,
        durationLeft: '44 days',
        startDate: this.startDate,
        endDate: this.endDate,
        userLicensesDetails: userLicense
      },
      paymentDetails: [
        {
          cost: newDeviceCost, currency: 'INR', paidDate: new Date().toISOString().split("T")[0],
          paidFor: this.selectedPaidByCountryName + '-' + (this.paidByMobileNumber != null ? this.paidByMobileNumber : ''),
          paidBy: this.selectedPaidForCountryName + '-' + this.paidForMobileNumber,
          paymentMode: this.selectedPaymentMode, referenceID: this.referenceID,
          gstPercent: 18, gstCost: 4949.82, isNewDevicePayment: true, isBluEyeRenewalPayment: false,
          isAdditionalBluPodPayment: false, isAdditionalUserLicensePayment: false,
        }
      ],
      isAdditionalDevice: true,
      additionalDiscountPercent: null,
      additionalDiscountCost: null,
      isActive: true,
      termsAccepted: false,
      totalCost: 0
    };
    // Push the new device
    this.bluEyePolicyObject.devicesDetails.push(emptyDevice);
    // Add a corresponding save state tracking object
    // Ensure root cost exists and update it
    if (!this.bluEyePolicyObject.paymentDetails.amount) {
      this.bluEyePolicyObject.paymentDetails.amount = 0;
    }
    this.bluEyePolicyObject.paymentDetails.amount += newDeviceCost;
    this.updateRootPaymentCost();
  }

  public removeCardFromDevicesList(index: number) {
    const removedDevice = this.bluEyePolicyObject.devicesDetails[index];
    if (removedDevice?.paymentDetails && this.bluEyePolicyObject.paymentDetails.amount) {
      const totalDeviceCost = removedDevice.paymentDetails.reduce((sum, payment) => sum + payment.cost, 0);
      this.bluEyePolicyObject.paymentDetails.amount -= totalDeviceCost;
    }
    // Remove the device and its state tracking
    this.bluEyePolicyObject.devicesDetails.splice(index, 1);
    this.deviceSaveState.splice(index, 1);
    this.updateRootPaymentCost();
  }

  public validationErrors: string[] = [];

  public validateDeviceNumber(index: number) {
    const device = this.bluEyePolicyObject.devicesDetails[index];
    // Ensure `device.bluePod.id` is properly initialized
    if (!device || typeof device.bluePod.id !== "string") {
      this.validationErrors[index] = "Device number is required.";
      return false;
    }
    const inputValue = device.bluePod.id.trim(); // Trim spaces
    if (!inputValue) {
      this.validationErrors[index] = "Device number is required.";
      return false;
    }
    const pattern = /^[A-Z0-9\-\/]{1,12}$/i; // Allows A-Z, 0-9, -, /
    if (!pattern.test(inputValue)) {
      this.validationErrors[index] = "Invalid format. Use A-Z, 0-9, -, / (1-12 chars).";
    } else {
      this.validationErrors[index] = ""; // Clear error if valid
    }
  }

  public addNewUserLicense(selectedDeviceID?: any, deviceIndex?: number) {
    let selectedDevice: any;
    if (typeof selectedDeviceID === 'object' && selectedDeviceID !== null) {
      selectedDevice = selectedDeviceID;
    } else if (deviceIndex !== undefined && this.bluEyePolicyObject?.devicesDetails?.[deviceIndex]) {
      selectedDevice = this.bluEyePolicyObject.devicesDetails[deviceIndex];
    } else if (selectedDeviceID) {
      selectedDevice = this.bluEyePolicyObject?.devicesDetails?.find(
        (device: any) => (device._id && device._id === selectedDeviceID) || (device.id && device.id === selectedDeviceID)
      );
    }
    if (!selectedDevice) return;

    if (!selectedDevice.bluEye) {
      selectedDevice.bluEye = { userLicensesDetails: [] };
    }
    if (!selectedDevice.bluEye.userLicensesDetails) {
      selectedDevice.bluEye.userLicensesDetails = [];
    }

    // device ki vunna ids (role)
    const assignedUserLicensesRoles = selectedDevice.bluEye.userLicensesDetails.map(
      (license: any) => license.roleName
    );

    const isFarm = this.businessEntity?.businessType?.[0]?.name === 'Farm' ||
      (typeof this.businessEntity?.businessType === 'string' && this.businessEntity?.businessType === 'Farm') ||
      this.policyDetails?.businessType === 'Farm' ||
      this.bluEyePolicyObject?.businessType === 'Farm' ||
      this.bluEyePolicyObject?.policyDetails?.businessType === 'Farm';

    // policy lo roles accepted
    let unAssignedUserRoles: any[] = [];
    if (isFarm) {
      const defaultFarmRoles = [
        { roleID: '61712f64e37ea5001eb52ab6', roleName: 'Farmer' },
        { roleID: '61712f8ce37ea5001eb52ab7', roleName: 'Farm Manager' },
        { roleID: '61712face37ea5001eb52ab8', roleName: 'Farm Tech' }
      ];

      const policyFarmRoles = this.creditPolicy?.devices?.[0]?.userLicenses?.rolesAccepted?.filter(
        (role: any) => ['Farmer', 'Farm Manager', 'Farm Tech'].includes(role.roleName)
      ) || [];

      const farmRolesMap = new Map<string, any>();
      defaultFarmRoles.forEach(r => farmRolesMap.set(r.roleName, r));
      policyFarmRoles.forEach((r: any) => {
        if (r && r.roleName) {
          farmRolesMap.set(r.roleName, {
            roleID: r.roleID || r._id || farmRolesMap.get(r.roleName)?.roleID,
            roleName: r.roleName
          });
        }
      });

      const farmRoles = Array.from(farmRolesMap.values());
      unAssignedUserRoles = farmRoles.filter(
        (role) => !assignedUserLicensesRoles.includes(role.roleName)
      );
    } else {
      const policyRoles = this.creditPolicy?.devices?.[0]?.userLicenses?.rolesAccepted || [];
      unAssignedUserRoles = policyRoles.filter(
        (role: any) => !assignedUserLicensesRoles.includes(role.roleName)
      );
    }

    for (let role of unAssignedUserRoles) {
      selectedDevice.bluEye.userLicensesDetails.push({
        roleID: role.roleID,
        roleName: role.roleName,
        noOfLicenses: 1,
        cost: 999,
        gstPercent: null,
        gstCost: null,
        isDefault: false,
      });
    }
    this.updateUserLicensePaymentDetails(selectedDevice);
  }

  public removeUserLicense(selectedDeviceID?: any, index?: number, deviceIndex?: number) {
    let selectedDevice: any;
    if (typeof selectedDeviceID === 'object' && selectedDeviceID !== null) {
      selectedDevice = selectedDeviceID;
    } else if (deviceIndex !== undefined && this.bluEyePolicyObject?.devicesDetails?.[deviceIndex]) {
      selectedDevice = this.bluEyePolicyObject.devicesDetails[deviceIndex];
    } else if (selectedDeviceID) {
      selectedDevice = this.bluEyePolicyObject?.devicesDetails?.find(
        (device: any) => (device._id && device._id === selectedDeviceID) || (device.id && device.id === selectedDeviceID)
      );
    }
    if (!selectedDevice || !selectedDevice.bluEye?.userLicensesDetails || index === undefined) return;
    selectedDevice.bluEye.userLicensesDetails.splice(index, 1);
    this.updateUserLicensePaymentDetails(selectedDevice);
  }

  public updateUserLicense(selectedDeviceID?: any, roleID?: string, change: number = 0, deviceIndex?: number) {
    let selectedDevice: any;
    if (typeof selectedDeviceID === 'object' && selectedDeviceID !== null) {
      selectedDevice = selectedDeviceID;
    } else if (deviceIndex !== undefined && this.bluEyePolicyObject?.devicesDetails?.[deviceIndex]) {
      selectedDevice = this.bluEyePolicyObject.devicesDetails[deviceIndex];
    } else if (selectedDeviceID) {
      selectedDevice = this.bluEyePolicyObject?.devicesDetails?.find(
        (device: any) => (device._id && device._id === selectedDeviceID) || (device.id && device.id === selectedDeviceID)
      );
    }
    if (!selectedDevice || !selectedDevice.bluEye?.userLicensesDetails) return;
    const license = selectedDevice.bluEye.userLicensesDetails.find(
      (ul: any) => ul.roleID === roleID
    );
    if (!license) return;
    license.noOfLicenses = Math.max(license.isDefault ? 1 : 0, license.noOfLicenses + change);
    this.updateUserLicensePaymentDetails(selectedDevice);
  }

  private updateUserLicensePaymentDetails(selectedDevice: DeviceDetails) {
    const totalAdditionalLicenses = selectedDevice.bluEye.userLicensesDetails.reduce((sum, ul) => {
      return sum + (ul.isDefault ? Math.max(ul.noOfLicenses - 1, 0) : ul.noOfLicenses);
    }, 0);
    const paymentIndex = selectedDevice?.paymentDetails?.findIndex(p => p.isAdditionalUserLicensePayment);
    const additionalCost = totalAdditionalLicenses * 999;
    selectedDevice.totalCost = additionalCost;
    if (!this.bluEyePolicyObject.paymentDetails.amount) {
      this.bluEyePolicyObject.paymentDetails.amount = 0; // Ensure root cost is initialized
    }
    if (totalAdditionalLicenses > 0) {
      if (paymentIndex > -1) {
        const previousCost = selectedDevice.paymentDetails[paymentIndex].cost;
        selectedDevice.paymentDetails[paymentIndex].cost = additionalCost;
        // Update root-level amount
        this.bluEyePolicyObject.paymentDetails.amount += (additionalCost - previousCost);
      } else {
        selectedDevice.paymentDetails.push({
          cost: additionalCost,
          currency: "INR",
          paidDate: new Date().toISOString().split("T")[0],
          paidFor: this.selectedPaidByCountryName + '-' + (this.paidByMobileNumber ?? ''),
          paidBy: this.selectedPaidForCountryName + '-' + this.paidForMobileNumber,
          paymentMode: this.selectedPaymentMode,
          referenceID: this.referenceID,
          gstPercent: null,
          gstCost: null,
          isNewDevicePayment: false,
          isBluEyeRenewalPayment: false,
          isAdditionalBluPodPayment: false,
          isAdditionalUserLicensePayment: true
        });
        // Add new cost to root-level amount
        this.bluEyePolicyObject.paymentDetails.amount += additionalCost;
      }
    } else if (paymentIndex > -1) {
      const removedPayment = selectedDevice.paymentDetails[paymentIndex];
      selectedDevice.paymentDetails.splice(paymentIndex, 1);
      // Remove cost from root-level amount
      this.bluEyePolicyObject.paymentDetails.amount -= removedPayment.cost;
    }
    this.updateRootPaymentCost();
  }

  public selectedRenewal: any = null; // Stores selected renewal option
  public renewalStates: { [deviceId: string]: { isChecked: boolean; selectedRenewal: any } } = {};

  public toggleRenewal(event: any, selectedDeviceID?: any, deviceIndex?: number) {
    const isChecked = event.target.checked;
    // Find the selected device
    let selectedDevice: any;
    if (typeof selectedDeviceID === 'object' && selectedDeviceID !== null) {
      selectedDevice = selectedDeviceID;
    } else if (deviceIndex !== undefined && this.bluEyePolicyObject?.devicesDetails?.[deviceIndex]) {
      selectedDevice = this.bluEyePolicyObject.devicesDetails[deviceIndex];
    } else if (selectedDeviceID) {
      selectedDevice = this.bluEyePolicyObject?.devicesDetails?.find(
        (device: any) => (device._id && device._id === selectedDeviceID) || (device.id && device.id === selectedDeviceID)
      );
    }
    if (!selectedDevice) return;
    if (!selectedDevice['renewalState']) {
      selectedDevice['renewalState'] = {isChecked: false, selectedRenewal: null};
    }
    selectedDevice['renewalState'].isChecked = isChecked;
    if (!isChecked) {
      selectedDevice['renewalState'].selectedRenewal = null;
      selectedDevice.totalCost = 0;
      // Remove renewal payment if exists
      const paymentIndex = selectedDevice.paymentDetails?.findIndex(payment => payment.isBluEyeRenewalPayment);
      if (paymentIndex !== -1) {
        const removedPayment = selectedDevice.paymentDetails[paymentIndex];
        selectedDevice.paymentDetails.splice(paymentIndex, 1);
        // Update root-level paymentDetails.cost
        this.bluEyePolicyObject.paymentDetails.amount -= removedPayment.cost;
      }
    }
    this.updateRootPaymentCost(); // Ensure root-level cost stays correct
    this.cdr.detectChanges(); // Force UI update
  }

  public onRenewalChange(event: any, selectedDeviceID?: any, deviceIndex?: number) {
    const selectedId = event.target.value;
    const selectedRenewal = this.creditPolicy?.devices?.[0]?.renewals?.find(r => r._id === selectedId);
    let selectedDevice: any;
    if (typeof selectedDeviceID === 'object' && selectedDeviceID !== null) {
      selectedDevice = selectedDeviceID;
    } else if (deviceIndex !== undefined && this.bluEyePolicyObject?.devicesDetails?.[deviceIndex]) {
      selectedDevice = this.bluEyePolicyObject.devicesDetails[deviceIndex];
    } else if (selectedDeviceID) {
      selectedDevice = this.bluEyePolicyObject?.devicesDetails?.find(
        (device: any) => (device._id && device._id === selectedDeviceID) || (device.id && device.id === selectedDeviceID)
      );
    }
    const deviceCpy = selectedDevice;
    if (!selectedDevice) return;
    if (!selectedDevice['renewalState']) {
      selectedDevice['renewalState'] = {isChecked: true, selectedRenewal: null};
    }
    selectedDevice['renewalState'].selectedRenewal = selectedRenewal;
    selectedDevice.isActive = false;
    selectedDevice.bluEye.endDate = moment(deviceCpy.bluEye.endDate).format('YYYY-MM-DD').toString();
    selectedDevice.bluEye.durationLeft = deviceCpy.bluEye.durationLeft;
    selectedDevice.termsAccepted = deviceCpy.termsAccepted;
    if (selectedRenewal) {
      // Remove old renewal payment
      const paymentIndex = selectedDevice.paymentDetails?.findIndex(payment => payment.isBluEyeRenewalPayment);
      selectedDevice.isActive = true;
      selectedDevice.bluEye.endDate = moment(this.endDate).format('YYYY-MM-DD').toString();
      const start = moment(this.startDate, 'YYYY-MM-DD');
      const end = moment(this.endDate, 'YYYY-MM-DD');

      const diffDays = end.diff(start, 'days');
      const validity = diffDays + 1;
      const duration = validity - 1;
      selectedDevice.bluEye.durationLeft = `${duration} days`;
      selectedDevice.bluEye.validity = `${validity} days`;
      selectedDevice.termsAccepted = true;
      if (paymentIndex !== -1) {
        const removedPayment = selectedDevice.paymentDetails[paymentIndex];
        selectedDevice.paymentDetails.splice(paymentIndex, 1);
        // Ensure paymentDetails.amount exists and is a number before subtraction
        if (!this.bluEyePolicyObject.paymentDetails.amount) {
          this.bluEyePolicyObject.paymentDetails.amount = 0;
        }
        this.bluEyePolicyObject.paymentDetails.amount -= removedPayment.cost || 0; // Ensure cost exists
      }
      // Calculate new payment cost
      const renewalCost = selectedRenewal.blueEyeCost + (selectedRenewal.blueEyeCost * 0.18);
      selectedDevice.totalCost = renewalCost;
      // Add new renewal payment
      selectedDevice.paymentDetails.push({
        cost: renewalCost,
        currency: "INR",
        paidDate: new Date().toISOString().split("T")[0],
        paidFor: this.selectedPaidByCountryName + '-' + (this.paidByMobileNumber ?? ''),
        paidBy: this.selectedPaidForCountryName + '-' + this.paidForMobileNumber,
        paymentMode: this.selectedPaymentMode,
        referenceID: this.referenceID,
        gstPercent: 18,
        gstCost: selectedRenewal.blueEyeCost * 0.18,
        isNewDevicePayment: false,
        isBluEyeRenewalPayment: true,
        isAdditionalBluPodPayment: false,
        isAdditionalUserLicensePayment: false
      });
      // Update root-level paymentDetails.cost
      this.bluEyePolicyObject.paymentDetails.amount += renewalCost;
    }
    this.updateRootPaymentCost(); // Ensure root-level cost stays correct
    this.cdr.detectChanges(); // Force UI update
  }

  private updateRootPaymentCost() {
    this.bluEyePolicyObject.paymentDetails.amount = 0; // Reset cost
    // Sum up payments for all devices
    this.bluEyePolicyObject.devicesDetails.forEach(device => {
      if (device.paymentDetails) {
        device.paymentDetails.forEach(payment => {
          this.bluEyePolicyObject.paymentDetails.amount += payment.cost;
        });
      }
    });
    this.registerForm.patchValue({
      paidAmount: this.bluEyePolicyObject.paymentDetails.amount.toFixed(2)
    });
  }

  public saveUserLicenses(index: number) {
    const selectedDevice = this.bluEyePolicyObject.devicesDetails[index];
    if (!selectedDevice) return;
    // Check if the device is inactive and requires a renewal selection
    if (!selectedDevice.isActive && selectedDevice['renewalState']?.isChecked && !selectedDevice['renewalState']?.selectedRenewal) {
      alert(`🚨 Please select a renewal option for this inactive device.`);
      return; // Stop saving process
    }
    //If validation passes, update save state
    this.deviceSaveState[index] = {
      message: '✅ Details saved successfully!',
      isSaved: true,
    };
  }

  public cancelDeviceChanges(index: number) {
    if (this.backupBluEyePolicyObject && this.backupBluEyePolicyObject.devicesDetails[index]) {
      const canceledDevice = this.bluEyePolicyObject.devicesDetails[index]; // Current device before reverting
      const backupDevice = this.backupBluEyePolicyObject.devicesDetails[index]; // Backup device before changes
      // Step 1: Remove the added cost of the modified device
      if (canceledDevice.paymentDetails && this.bluEyePolicyObject.paymentDetails.amount) {
        const totalDeviceCost = canceledDevice.paymentDetails.reduce((sum, payment) => sum + payment.cost, 0);
        this.bluEyePolicyObject.paymentDetails.amount -= totalDeviceCost;
      }
      // Step 2: Restore the previous device from backup
      this.bluEyePolicyObject.devicesDetails[index] = JSON.parse(JSON.stringify(backupDevice));
      // Step 3: Add back the original payment details from backup
      if (backupDevice.paymentDetails && this.bluEyePolicyObject.paymentDetails.amount) {
        const totalBackupDeviceCost = backupDevice.paymentDetails.reduce((sum, payment) => sum + payment.cost, 0);
        this.bluEyePolicyObject.paymentDetails.amount += totalBackupDeviceCost;
      }
      this.deviceSaveState[index] = {
        message: '✅ Changes reverted successfully!',
        isSaved: false,
      };
    }
    this.registerForm.patchValue({
      paidAmount: this.bluEyePolicyObject.paymentDetails.amount
    });
  }

  async updateTermsOfBusiness(event?: MatCheckboxChange) {
    if (!this.policyTypeName) {
      this.toastr.error('Please select Subscription Policy Type');
      this.isPolicyAccepted = false;
      if (event?.source) {
        event.source.checked = false;
      }
      return;
    }

    if (!this.policyId || !this.creditPolicy?.policyName) {
      this.toastr.error('Please select Policy Name');
      this.isPolicyAccepted = false;
      if (event?.source) {
        event.source.checked = false;
      }
      return;
    }

    if (!this.businessEntity?.id) {
      this.toastr.error('Please enter paid for mobile number');
      this.isPolicyAccepted = false;
      if (event?.source) {
        event.source.checked = false;
      }
      return;
    }

    try {
      this.isPolicyAccepted = event ? event.checked : !this.isPolicyAccepted;
      this.termsAccepted = this.isPolicyAccepted;
      this.registerForm.patchValue({ termsAccepted: this.isPolicyAccepted });
      if (this.isPolicyAccepted) {
        this.toastr.success('Terms and Conditions accepted');
      }
    } catch (error) {
      this.isPolicyAccepted = false;
      if (event?.source) {
        event.source.checked = false;
      }
      this.toastr.error('Failed to accept Terms and Conditions');
    }
  }

  public syncDeviceNumbers(index: number) {
    this.bluEyePolicyObject.devicesDetails[index].bluePod.id =
      this.bluEyePolicyObject.devicesDetails[index].deviceNumber;
  }

  matchedDevices: any;
  matchedInActiveDevices: any;
  matchedActiveDevices: any;
  sameMatchingDevice: any;
  finalmatchedDevice: any;
  deviceMessages: string[] = [];
  async checkDeviceNumber(number: string, index: number) {
    this.deviceMessages[index] = '';
    this.matchedActiveDevices = [];
    this.matchedInActiveDevices = [];
    this.matchedDevices = [];
    this.sameMatchingDevice = [];
    this.finalmatchedDevice = [];
    for (let item of this.bluEyeSubscribers) {
      if (item.policyDetails?.name === "BluEye Launch Plan") {
        const hasMatchingDevice = Array.isArray(item.devicesDetails) &&
          item.devicesDetails.some(device => device?.bluePod?.id?.toLowerCase() === number.toLowerCase());
        if (hasMatchingDevice) {
          this.matchedDevices.push(item); // Push the entire object
        }
      }
    }
    this.matchedInActiveDevices = this.matchedDevices[0];
    if (this.matchedInActiveDevices) {
      this.finalmatchedDevice = this.matchedInActiveDevices.devicesDetails.filter(
        (device: any) => device.deviceNumber.toLowerCase() === number.toLowerCase()
      );
      const businessName = this.matchedInActiveDevices.businessName;
      this.deviceMessages[index] = this.finalmatchedDevice?.[0].isActive ?
        `This device number is already active under ${businessName} business and cannot be added/renewed to the current business`
        : '';
    } else {
      const devicesList = this.bluEyePolicyObject.devicesDetails.filter(
        (device: any, i: number) =>
          device.deviceNumber?.toLowerCase() === number.toLowerCase() && i !== index
      );

      this.sameMatchingDevice = devicesList.filter(
        (device: any) =>
          device.deviceNumber?.toLowerCase() === number.toLowerCase()
      );
      if (this.sameMatchingDevice.length > 0) {
        this.deviceMessages[index] =
          `This device number is already provided within the same business and cannot be mentioned again`;
      } else {
        this.deviceMessages[index] = '';
      }
    }
  }

  public async subscribeBluEyePolicy() {
    if (!this.isPolicyAccepted) {
      this.toastr.error('Accept Terms & Conditions before proceeding');
      return false;
    }
    try {
      if (typeof this.backupBluEyePolicyObject != 'undefined') {
        if (this.validateExistingPolicyDevices()) {
          let finalUpdateAddButton
          let finalUpdate
          if (this.alreadyPolicyObject && !this.updateButton) {
            this.startDate = moment(this.selected?.startDate).format('YYYY-MM-DD').toString();
            this.endDate = moment(this.selected?.endDate).format('YYYY-MM-DD').toString();
            this.bluEyePolicyObject = this.appendDatesToLastDevice(this.bluEyePolicyObject, this.startDate, this.endDate);
            // Assume these are already availableclosePUDetails
            const filePath = this.filePath; // your uploaded path
            const updatedPolicyObject = { ...this.bluEyePolicyObject };
            // 1. Add to top-level paymentReceipts[]
            if (updatedPolicyObject.paymentDetails) {
              if (!Array.isArray(updatedPolicyObject.paymentDetails.paymentReceipts)) {
                updatedPolicyObject.paymentDetails.paymentReceipts = [];
              }
              // Only push if not already present
              if (!updatedPolicyObject.paymentDetails.paymentReceipts.includes(filePath)) {
                updatedPolicyObject.paymentDetails.paymentReceipts.push(filePath);
              }
            }
            //2. Add filePath to last device's first paymentDetail
            const lastDeviceIndex = updatedPolicyObject.devicesDetails.length - 1;
            const lastDevice = updatedPolicyObject.devicesDetails[lastDeviceIndex];
            if (lastDevice && Array.isArray(lastDevice.paymentDetails) && lastDevice.paymentDetails.length > 0) {
              lastDevice.paymentDetails[0].filePath = filePath;
            }
            // Reassign the modified device back
            updatedPolicyObject.devicesDetails[lastDeviceIndex] = lastDevice;
            // (Optional) Debug log
            finalUpdateAddButton = this.addDevice(this.alreadyPolicyObject, updatedPolicyObject);
            if (Object.keys(finalUpdateAddButton).length === 0 || (!finalUpdateAddButton.devicesDetails && !finalUpdateAddButton.paymentDetails)) {
              return false;
            }
          }
          if (this.updateButton) {
            const filePath = this.filePath; // your current uploaded file path
            const updatedPolicyObject = { ...this.bluEyePolicyObject };
            //Step 1: Push filePath into top-level paymentReceipts if it exists and not already there
            if (filePath && updatedPolicyObject.paymentDetails) {
              if (!Array.isArray(updatedPolicyObject.paymentDetails.paymentReceipts)) {
                updatedPolicyObject.paymentDetails.paymentReceipts = [];
              }
              const alreadyExists = updatedPolicyObject.paymentDetails.paymentReceipts.includes(filePath);
              if (!alreadyExists) {
                updatedPolicyObject.paymentDetails.paymentReceipts.push(filePath);
              }
            }
            // Step 2: Replace filePath in last device's paymentDetails[0] if filePath exists
            const devices = updatedPolicyObject.devicesDetails;
            if (filePath && Array.isArray(devices) && devices.length > 0) {
              const lastDevice = devices[devices.length - 1];
              if (Array.isArray(lastDevice.paymentDetails) && lastDevice.paymentDetails.length > 0) {
                lastDevice.paymentDetails[0].filePath = filePath;
              }
            }
            this.bluEyePolicyObject.devicesDetails[0].bluEye.startDate = moment(this.selected?.startDate).format('YYYY-MM-DD').toString();
            this.bluEyePolicyObject.devicesDetails[0].bluEye.endDate = moment(this.selected?.endDate).format('YYYY-MM-DD').toString();
            finalUpdate = this.transformData(this.selectedPolicyObject, this.bluEyePolicyObject);
            if (Object.keys(finalUpdate).length === 0 || (!finalUpdate.devicesDetails && !finalUpdate.paymentDetails)) {
              return false;
            }
          }
          this.creditManager.isBH = 0;
          // return
          const existingPolicyUpdated = await this.creditsManagersService.updateOneByID(this.bluEyePolicyObject.id, finalUpdate ? finalUpdate : finalUpdateAddButton);
          if (existingPolicyUpdated) {
            this.toastr.success('Policy updated sucessfully');
            this.matchedActiveDevices = [];
            this.matchedInActiveDevices = [];
            this.sameMatchingDevice = [];
            const existingPolicyObject = this.filteredBluEyeSubscribers.findIndex((subscriber) => subscriber.id === this.bluEyePolicyObject.id);
            if (existingPolicyObject != -1) {
              this.filteredBluEyeSubscribers[existingPolicyObject] = this.bluEyePolicyObject;
              this.filteredBluEyeSubscribers = this.filteredBluEyeSubscribers.filter((element, index) => this.filteredBluEyeSubscribers.findIndex(Object => Object.id === element.id) === index);
              this.bluEyeSubscribers[existingPolicyObject] = this.bluEyePolicyObject;
              this.bluEyeSubscribers = this.bluEyeSubscribers.filter((element, index) => this.bluEyeSubscribers.findIndex(Object => Object.id === element.id) === index);
              this.ngOnInit();
              this.switchPolicyTypeData('blueEyePlan');
            }
          }
        }
      } else {
        this.amountPaidDate = new Date(this.amountPaidDate);
        this.amountPaidDate = (this.amountPaidDate.getFullYear() > 0 ? this.amountPaidDate.getFullYear() : this.amountPaidDate.getFullYear() * -1) + '-' + (this.amountPaidDate.getMonth() + 1) + '-' + this.amountPaidDate.getDate();
        this.bluEyePolicyObject = {
          isExpired: false,
          personID: this.personEntity?.[0]?.id ? this.personEntity[0].id : null,
          businessID: this.businessEntity.id,
          creditPolicyID: this.creditPolicy?.id,
          subscriptionStartDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          subscriptionEndDate: null,
          createdBy: localStorage.getItem('loginPersonId'),
          updatedBy: localStorage.getItem('loginPersonId'),
          updated: false,
          businessName: this.businessName,
          personName: this.personName ? this.personName : null,
          termsAccepted: true,
          durationLeft: {
            period: Number(this.creditPolicy?.validityPeriod.duration),
            unit: this.creditPolicy?.validityPeriod.unit
          },
          policyDetails: {
            id: this.creditPolicy?.id,
            name: this.creditPolicy?.policyName,
            policyFlag: 'BELP'
          },
          paymentDetails: {
            amount: this.paidAmount,
            currency: 'INR',
            paidDate: moment(new Date()).format('YYYY-MM-DD').toString(),
            paidBy: this.selectedPaidByCountryName + '-' + this.paidByMobileNumber,
            paidFor: this.selectedPaidForCountryName + '-' + this.paidForMobileNumber,
            paymentMode: this.selectedPaymentMode ?? '',
            referenceID: this.referenceID ?? '',
            gstPercent: 0,
            gstCost: 0
          },
          devicesDetails: this.bluEyePolicyObject?.devicesDetails ?? []
        }
        const start = moment(this.selected?.startDate);
        const end = moment(this.selected?.endDate);
        const diffDays = start.isValid() && end.isValid() ? (end.diff(start, 'days')) : 0;
        const validity = diffDays + 1;
        const duration = validity - 1;
        this.bluEyePolicyObject.devicesDetails.forEach(device => {
          if (device.bluEye) {
            const now = moment();

            const startWithTime = moment(start)
              .set({
                hour: now.hour(),
                minute: now.minute(),
                second: now.second(),
                millisecond: now.millisecond()
              })
              .toISOString(); // UTC format with Z

            const endWithTime = moment(end)
              .set({
                hour: now.hour(),
                minute: now.minute(),
                second: now.second(),
                millisecond: now.millisecond()
              })
              .toISOString(); // UTC format with Z
            device.bluEye.startDate = startWithTime;
            device.bluEye.endDate = endWithTime;
            device.bluEye.durationLeft = `${duration} days`;
            device.bluEye.validity = `${validity} days`;
          }
        });
        if (this.validateNewPolicyDevices()) {
          const updatedPolicyObject = { ...this.bluEyePolicyObject };
          // Top-level
          if (updatedPolicyObject.paymentDetails) {
            updatedPolicyObject.paymentDetails.paymentReceipts = [this.filePath];
          }
          // Per-device
          updatedPolicyObject.devicesDetails = updatedPolicyObject.devicesDetails.map((device) => {
            if (Array.isArray(device.paymentDetails)) {
              device.paymentDetails = device.paymentDetails.map((payment) => {
                const updated = { ...payment, filePath: this.filePath };
                return updated;
              });
            }
            return device;
          });
          // return
          this.bluEyePolicyObject.isBH = 0;
          const newPolicyAdded = await this.creditsManagersService.create(this.bluEyePolicyObject);
          if (newPolicyAdded) {
            this.toastr.success('Policy added sucessfully');
            this.bluEyeSubscribers.unshift(newPolicyAdded);
            this.filteredBluEyeSubscribers.unshift(newPolicyAdded);
            this.subscribersList.unshift(newPolicyAdded);
            this.sameMatchingDevice = [];
            this.matchedActiveDevices = [];
            this.matchedInActiveDevices = [];
            this.ngOnInit();
            this.switchPolicyTypeData('blueEyePlan');
          }
        }
      }
    } catch (error) {
      alert(error);
    }
    this.onFormClose();
  }

  appendDatesToLastDevice(bluEyePolicyInput: any, startDate: string, endDate: string) {
    const now = moment();

    const formatStart = moment(startDate)
      .set({
        hour: now.hour(),
        minute: now.minute(),
        second: now.second()
      })
      .toISOString(); // Adds timezone (UTC with 'Z')

    const formatEnd = moment(endDate)
      .set({
        hour: now.hour(),
        minute: now.minute(),
        second: now.second()
      })
      .toISOString(); // Adds timezone (UTC with 'Z')

    const start = moment(formatStart);
    const end = moment(formatEnd);
    const diffDays = end.diff(start, 'days');
    const validity = diffDays + 1;
    const duration = validity - 1;
    const applyDates = (policy: any) => {
      if (policy.devicesDetails && policy.devicesDetails.length > 0) {
        const lastDevice = policy.devicesDetails[policy.devicesDetails.length - 1];
        if (!lastDevice.bluEye) {
          lastDevice.bluEye = {};
        }
        lastDevice.bluEye.startDate = formatStart;
        lastDevice.bluEye.endDate = formatEnd;
        lastDevice.bluEye.durationLeft = `${duration} days`;
        lastDevice.bluEye.validity = `${validity} days`;
      }
    };
    if (Array.isArray(bluEyePolicyInput)) {
      bluEyePolicyInput.forEach(policy => applyDates(policy));
    } else {
      applyDates(bluEyePolicyInput);
    }
    return bluEyePolicyInput;
  }

  addDevice(original, updated) {
    const transformed: Record<string, any> = {};
    // 1. Compare top-level paymentDetails
    const origPay = original.paymentDetails || {};
    const updPay = updated.paymentDetails || {};
    const trackedFields = ["paidBy", "amount", "referenceID", "paymentMode"];
    const additionalFields = ["currency", "paidFor", "gstPercent", "gstCost"];
    const paymentChanged = trackedFields.some(key => origPay[key] !== updPay[key]);
    if (paymentChanged) {
      transformed.paymentDetails = {
        paidDate: new Date().toISOString()
      };
      // Include changed tracked fields with updated values
      trackedFields.forEach((key) => {
        transformed.paymentDetails[key] = updPay[key];
      });
      // Include unchanged additional fields from original
      additionalFields.forEach((key) => {
        transformed.paymentDetails[key] = origPay[key];
      });
      // Include paymentReceipts array from updated if available
      if (Array.isArray(updPay.paymentReceipts)) {
        transformed.paymentDetails.paymentReceipts = [...updPay.paymentReceipts];
      }
    }
    // 2. Compare devicesDetails
    const origDevices = original.devicesDetails || [];
    const updDevices = updated.devicesDetails || [];
    const updatedDevices = updDevices.map((updDev) => {
      const origDev = origDevices.find((o) => o._id === updDev._id);
      const updBluEye = updDev.bluEye || {};
      const origBluEye = origDev?.bluEye || {};
      let changedLicenses: any[] = [];
      if (!origDev) {
        // Full new device added
        return {
          ...updDev
        };
      } else {
        // Compare licenses
        const origLicenses = origBluEye.userLicensesDetails || [];
        const updLicenses = updBluEye.userLicensesDetails || [];
        changedLicenses = updLicenses.map(uLic => {
          const match = origLicenses.find(oLic => oLic._id === uLic._id);
          if (!match) {
            return uLic; // new license
          } else if (uLic.noOfLicenses !== match.noOfLicenses) {
            return {
              _id: uLic._id,
              noOfLicenses: uLic.noOfLicenses
            }; // updated license
          }
          return null; // no change
        }).filter(Boolean);
      }
      // Compare paymentDetails
      const origPayments = origDev?.paymentDetails || [];
      const updPayments = updDev?.paymentDetails || [];
      const newPayments = updPayments.filter(
        upd => !origPayments.some(orig => orig._id === upd._id)
      );
      const hasChanges = changedLicenses.length > 0 || newPayments.length > 0;
      if (!hasChanges) return null;
      const totalLicenses = changedLicenses.reduce(
        (sum, lic) => sum + (lic.noOfLicenses || lic?.noOfLicenses || 0),
        0
      );
      const cost = totalLicenses * 999;
      return {
        _id: updDev._id,
        bluEye: {
          cost,
          userLicensesDetails: changedLicenses
        },
        paymentDetails: newPayments
      };
    }).filter(Boolean);
    if (updatedDevices.length > 0) {
      transformed.devicesDetails = updatedDevices;
    }
    if (Object.keys(transformed).length > 0) {
      transformed.isDeepUpdate = true;
    }
    return transformed;
  }

  onAmountBlur() {
    const value = this.registerForm.get('paidAmount')?.value;
    const amt = parseFloat(value);
    if (!isNaN(amt) && this.policyId && this.bluEyePolicyObject?.paymentDetails) {
      this.bluEyePolicyObject.paymentDetails.amount = amt;
    }
  }

  onReferenceChanged() {
    const referenceId = this.registerForm.get('referenceid')?.value;
    if (referenceId && this.bluEyePolicyObject?.paymentDetails) {
      this.bluEyePolicyObject.paymentDetails.referenceID = referenceId;
    }
  }

  transformData(original, updated) {
    const transformed: Record<string, any> = {};
    const origPay = original.paymentDetails || {};
    const updPay = updated.paymentDetails || {};
    const paymentFields = ["paidBy", "amount", "referenceID", "paymentMode", "paymentReceipts"];
    const additionalFields = ["currency", "paidFor", "gstPercent", "gstCost"];
    const hasChanged = paymentFields.some(key => origPay[key] !== updPay[key]);
    // Normalize dates
    (updated.devicesDetails || []).forEach((dev, index) => {
      const origDev = (original.devicesDetails || [])[index];
      const origBluEye = origDev?.bluEye || {};
      const updBluEye = dev.bluEye || {};
      if (updBluEye.startDate && origBluEye.startDate) {
        const orig = new Date(origBluEye.startDate).toISOString();
        const upd = new Date(updBluEye.startDate).toISOString();
        if (orig === upd) updBluEye.startDate = origBluEye.startDate;
      }
      if (updBluEye.endDate && origBluEye.endDate) {
        const orig = new Date(origBluEye.endDate).toISOString();
        const upd = new Date(updBluEye.endDate).toISOString();
        if (orig === upd) updBluEye.endDate = origBluEye.endDate;
      }
    });

    const anyDeviceInactive = (original.devicesDetails || []).some(d => d?.isActive === false);

    if (anyDeviceInactive) {
      transformed.isDeepUpdate = true;
      transformed.subscriptionEndDate = null;
      transformed.isExpired = false;
      transformed.termsAccepted = true;
      transformed.paymentDetails = {
        paidDate: new Date().toISOString()
      };
      paymentFields.forEach(key => {
        transformed.paymentDetails[key] = hasChanged ? updPay[key] : origPay[key];
      });
      additionalFields.forEach(key => {
        if (origPay[key] !== undefined) {
          transformed.paymentDetails[key] = origPay[key];
        }
      });

      transformed.devicesDetails = (updated.devicesDetails || []).map((updDev, index) => {
        const origDev = (original.devicesDetails || [])[index];
        if (origDev?.isActive !== false) return null;

        const origBluEye = origDev?.bluEye || {};
        const updBluEye = updDev.bluEye || {};
        const origLicenses = origBluEye.userLicensesDetails || [];
        const updLicenses = updBluEye.userLicensesDetails || [];

        const cleanedUserLicenses = updLicenses.map(uLic => {
          const match = origLicenses.find(oLic => oLic._id === uLic._id);
          if (!match) return uLic;
          if (uLic.noOfLicenses !== match.noOfLicenses) {
            return {
              _id: uLic._id,
              noOfLicenses: uLic.noOfLicenses
            };
          }
          return null;
        }).filter(Boolean);

        const now = moment();
        const formatStart = moment(updBluEye.startDate)
          .set({
            hour: now.hour(),
            minute: now.minute(),
            second: now.second()
          })
          .toISOString(); // Adds timezone (UTC with 'Z')
        const formatEnd = moment(updBluEye.endDate)
          .set({
            hour: now.hour(),
            minute: now.minute(),
            second: now.second()
          })
          .toISOString(); // Adds timezone (UTC with 'Z')
        const start = moment(formatStart);
        const end = moment(formatEnd);
        const diffDays = end.diff(start, 'days');
        const validity = diffDays + 1;
        const durationLeft = validity - 1;

        const device: any = {
          _id: updDev._id,
          isActive: true,
          termsAccepted: true,
          bluEye: {
            startDate: formatStart,
            endDate: formatEnd,
            durationLeft: `${durationLeft} days`,
            validity: `${validity} days`
          }
        };

        if (cleanedUserLicenses.length > 0) {
          device.bluEye.userLicensesDetails = cleanedUserLicenses;
        }

        const renewalPayments = (updDev.paymentDetails || []).filter(p => p?.isBluEyeRenewalPayment === true);
        if (renewalPayments.length > 0) {
          device.paymentDetails = renewalPayments;
        }

        const selectedRenewal = (updDev.renewalState || {}).selectedRenewal;
        if (selectedRenewal && selectedRenewal._id && selectedRenewal.companySize && selectedRenewal.blueEyeCost !== undefined) {
          device.renewalDetails = {
            renewalID: selectedRenewal._id,
            renewalCompanySize: selectedRenewal.companySize,
            bluEyeRenewalCost: selectedRenewal.blueEyeCost
          };
        }

        const origReceipts = (original.paymentDetails?.paymentReceipts || []).map(r => r?.filePath || r).filter(Boolean);
        const updReceipts = (updated.paymentDetails?.paymentReceipts || []).map(r => r?.filePath || r).filter(Boolean);
        const filePath = updReceipts.find(path => !origReceipts.includes(path));

        if (filePath && origDev.isActive === false) {
          if (!Array.isArray(device.paymentDetails)) {
            device.paymentDetails = [];
          }
          if (device.paymentDetails.length > 0) {
            device.paymentDetails[0].filePath = filePath;
          } else {
            device.paymentDetails = [{ filePath }];
          }
        }

        if (cleanedUserLicenses.length > 0 || origBluEye.startDate !== updBluEye.startDate || origBluEye.endDate !== updBluEye.endDate) {


          const now = moment();
          const formatStart = moment(updBluEye.startDate)
            .set({
              hour: now.hour(),
              minute: now.minute(),
              second: now.second()
            })
            .toISOString(); // Adds timezone (UTC with 'Z')
          const formatEnd = moment(updBluEye.endDate)
            .set({
              hour: now.hour(),
              minute: now.minute(),
              second: now.second()
            })
            .toISOString(); // Adds timezone (UTC with 'Z')
          const start = moment(formatStart);
          const end = moment(formatEnd);
          const diffDays = end.diff(start, 'days');
          const validity = diffDays + 1;
          const durationLeft = validity - 1;

          device.bluEye.startDate = formatStart;
          device.bluEye.endDate = formatEnd;
          device.bluEye.durationLeft = `${durationLeft} days`;
          device.bluEye.validity = `${validity} days`;
        }
        return device;
      }).filter(Boolean);
    } else {
      transformed.isDeepUpdate = true;
      if (hasChanged) {
        transformed.paymentDetails = {
          paidDate: new Date().toISOString()
        };
        paymentFields.forEach(key => {
          transformed.paymentDetails[key] = updPay[key];
        });
        additionalFields.forEach(key => {
          if (origPay[key] !== undefined) {
            transformed.paymentDetails[key] = origPay[key];
          }
        });
      }
      const updatedDevices = (updated.devicesDetails || []).map((updDev, index) => {
        const origDev = (original.devicesDetails || [])[index];
        if (origDev?.isActive !== true) return null;
        const updBluEye = updDev.bluEye || {};
        const origBluEye = origDev?.bluEye || {};
        const origLicenses = origBluEye.userLicensesDetails || [];
        const updLicenses = updBluEye.userLicensesDetails || [];
        const cleanedUserLicenses = updLicenses.map(uLic => {
          const match = origLicenses.find(oLic => oLic._id === uLic._id);
          if (!match) return uLic;
          if (uLic.noOfLicenses !== match.noOfLicenses) {
            return {
              _id: uLic._id,
              noOfLicenses: uLic.noOfLicenses
            };
          }
          return null;
        }).filter(Boolean);

        const isStartDateChanged = updBluEye.startDate !== origBluEye.startDate;
        const isEndDateChanged = updBluEye.endDate !== origBluEye.endDate;
        const device: any = {
          _id: updDev._id,
          bluEye: {}
        };
        if (cleanedUserLicenses.length === 0 && !isStartDateChanged && !isEndDateChanged) {
          return null;
        }
        if (cleanedUserLicenses.length > 0) {
          const totalLicenses = cleanedUserLicenses.reduce((sum, lic) => sum + (lic.noOfLicenses || 0), 0);
          const cost = totalLicenses * 999;
          device.bluEye.userLicensesDetails = cleanedUserLicenses;
          device.bluEye.cost = cost;
        }
        const origReceipts = (original.paymentDetails?.paymentReceipts || []).map(r => r?.filePath || r).filter(Boolean);
        const updReceipts = (updated.paymentDetails?.paymentReceipts || []).map(r => r?.filePath || r).filter(Boolean);
        const filePath = updReceipts.find(path => !origReceipts.includes(path));
        if (filePath && cleanedUserLicenses.length > 0) {
          if (!Array.isArray(device.paymentDetails)) {
            device.paymentDetails = [];
          }
          if (device.paymentDetails.length > 0) {
            device.paymentDetails[0].filePath = filePath;
          } else {
            device.paymentDetails = [{ filePath }];
          }
        }
        if (isStartDateChanged || isEndDateChanged) {
          const now = moment();
          const formatStart = moment(updBluEye.startDate)
            .set({
              hour: now.hour(),
              minute: now.minute(),
              second: now.second()
            })
            .toISOString(); // Adds timezone (UTC with 'Z')
          const formatEnd = moment(updBluEye.endDate)
            .set({
              hour: now.hour(),
              minute: now.minute(),
              second: now.second()
            })
            .toISOString(); // Adds timezone (UTC with 'Z')
          const start = moment(formatStart);
          const end = moment(formatEnd);
          const diffDays = end.diff(start, 'days');
          const validity = diffDays + 1;
          const durationLeft = validity - 1;

          device.bluEye.startDate = formatStart;
          device.bluEye.endDate = formatEnd;
          device.bluEye.durationLeft = `${durationLeft} days`;
          device.bluEye.validity = `${validity} days`;
        }
        const origPayments = origDev?.paymentDetails || [];
        const updPayments = updDev?.paymentDetails || [];
        const filteredPayments = updPayments.filter(upd => !origPayments.some(orig => orig._id === upd._id));
        if (filteredPayments.length > 0) {
          if (device.paymentDetails?.[0]?.filePath && !filteredPayments[0]?.filePath) {
            filteredPayments[0].filePath = device.paymentDetails[0].filePath;
          }
          device.paymentDetails = filteredPayments;
        }
        return device;
      }).filter(Boolean);

      if (updatedDevices.length > 0) {
        transformed.devicesDetails = updatedDevices;
      }

      // Only paymentReceipts changed
      const origReceiptPaths = (original.paymentDetails?.paymentReceipts || []).map(r => r?.filePath || r).filter(Boolean);
      const updReceiptPaths = (updated.paymentDetails?.paymentReceipts || []).map(r => r?.filePath || r).filter(Boolean);
      const receiptDiff = updReceiptPaths.find(path => !origReceiptPaths.includes(path));

      if (hasChanged && receiptDiff && (!transformed.devicesDetails || transformed.devicesDetails.length === 0)) {
        transformed.devicesDetails = (updated.devicesDetails || []).map(dev => ({
          _id: dev._id,
          paymentDetails: [{
            _id: dev.paymentDetails?.[0]?._id || undefined,
            filePath: receiptDiff
          }]
        }));
      }
    }
    return transformed;
  }

  selectedPolicyObject;
  any;

  /*edit subscription*/
  updateBusinessEntity: any;
  async onEditSubscriber(policyObject, device) {
    this.showForm = true;
    this.updateButton = true;
    this.submitButton = false;
    // Step 1: Deep clone policyObject
    const clonedPolicyObject = JSON.parse(JSON.stringify(policyObject));
    const matchedDeviceId = device._id;
    // Step 2: Find and deep clone the matched device
    const originalMatchedDevice = clonedPolicyObject.devicesDetails.find((d: any) => d._id === matchedDeviceId);
    const matchedDevice = originalMatchedDevice ? JSON.parse(JSON.stringify(originalMatchedDevice)) : null;
    if (matchedDevice) {
      // Step 3: Replace devicesDetails with only the deep cloned matched device
      clonedPolicyObject.devicesDetails = [matchedDevice];
    } else {
      console.warn('No matching device found in policy.devicesDetails.');
    }
    // Step 4: Assign cloned policy object to local variables
    this.selectedPolicyObject = JSON.parse(JSON.stringify(clonedPolicyObject)); // just in case!
    this.bluEyePolicyObject = clonedPolicyObject;
    this.backupBluEyePolicyObject = JSON.parse(JSON.stringify(clonedPolicyObject));
    this.isPopupOpen = false;
    this.updateButton = true;
    this.submitButton = false;
    this.enableDisableSubmitButton = false;
    this.creditManager = new CreditsManagersModel();
    this.selectedPaidForCountryName = this.bluEyePolicyObject.paymentDetails.paidFor?.split('-')[0] || '+91';
    this.selectedPaidByCountryName = this.bluEyePolicyObject.paymentDetails.paidBy?.split('-')[0] || '+91';
    this.policyId = this.bluEyePolicyObject.policyDetails.id;
    if (this.policyId) {
      this.getCreditPolicy();
    }
    this.paidForcountrySelected();
    this.policyTypeName = this.creditPolicy.creditType;
    this.paidForMobileNumber = this.bluEyePolicyObject.paymentDetails.paidFor?.split('-')[1];
    this.paidByMobileNumber = this.bluEyePolicyObject.paymentDetails.paidBy?.split('-')[1];
    this.paidAmount = this.bluEyePolicyObject.paymentDetails.amount;
    const paymentObject = this.paymentOptions.find(
      (paymentOption) => paymentOption.value === this.bluEyePolicyObject.paymentDetails.paymentMode
    );
    this.referenceID = this.bluEyePolicyObject.paymentDetails.referenceID;
    if (this.policyTypeName) {
      this.getCreditPoliciesByPolicyType();
    }

    // Log the filePath and fileName to see the results
    this.businessName = this.bluEyePolicyObject.businessName;
    this.personName = this.bluEyePolicyObject.personName;
    this.termsAccepted = false;
    this.isPolicyAccepted = false;
    this.amountPaidDate = moment(new Date()).format('DD-MMM-YYYY').toString();
    this.registerForm.patchValue({
      creditPolicyType: this.policyTypeName,
      creditPolicyName: this.bluEyePolicyObject.policyDetails.id,
      paidForCountryName: this.selectedPaidForCountryName,
      paidForMobileNumber: this.paidForMobileNumber,
      paidByCountryName: this.selectedPaidByCountryName,
      paidByMobileNumber: this.paidByMobileNumber,
      paidAmount: this.paidAmount,
      referenceid: this.referenceID,
      termsAccepted: false,
      /*startdate: startDateFormatted,
      enddate: endDateFormatted*/
    });
    if (paymentObject) {
      this.togglePaymentOption(paymentObject);
    }
    this.paidBycountrySelected();
    this.businessEntity = await this.businessEntityService.getOneByID(policyObject && policyObject.businessID);
  }

  public validateNewPolicyDevices(): boolean {
    if (this.bluEyePolicyObject.devicesDetails.length === 0) {
      this.toastr.error('Please add a new device before proceeding');
      return false;
    }
    for (const device of this.bluEyePolicyObject.devicesDetails) {
      if (!device.deviceNumber.trim()) {
        this.toastr.error('Device number cannot be empty');
        return false;
      }
    }
    return true; // Validation passed
  }

  public validateExistingPolicyDevices(event?: Event): boolean {
    if (event) {
      event.preventDefault(); // Prevent form submission if triggered by a button inside a form
    }
    if (this.bluEyePolicyObject.devicesDetails.length === 0) {
      this.toastr.error('Please add a new device before proceeding');
      return false;
    }
    for (const device of this.bluEyePolicyObject.devicesDetails) {
      if (!device.deviceNumber?.trim()) {
        this.toastr.error('Device number cannot be empty');
        return false;
      }
      // Check if the renewal checkbox is checked
      if (device.renewalState?.isChecked) {
        // Validate that a renewal option is selected
        if (!device.renewalState.selectedRenewal || !device.renewalState.selectedRenewal._id) {
          this.toastr.error(`Please select a renewal option for device: ${device.deviceNumber}`);
          return false;
        }
      }
    }
    return true; // Validation passed
  }

  /**
   * @method
   * Description:
   * This method will be called when user changes the country selection in paid for field and the purpose of this method is that based on the country selected i am updating the
   * mobile number validation check.
   */
  public paidForcountrySelected(): void {
    this.paidForMobileNumber = '';
    this.registerForm.patchValue({
      paidForMobileNumber: '',
    });
    this.businessName = '';
    this.personName = '';
    this.businessEntity = new BusinessEntity();
    this.personEntity = [];
    const countryCurrencyMap = {
      '+91': 'INR',
      '+61': 'AUD',
      '+593': 'USD',
      '+62': 'IDR',
      '+60': 'MYR',
      '+234': 'NGN',
      '+966': 'SAR',
      '+34': 'EUR'
    };
    if (this.selectedPaidForCountryName) {
      this.selectedPaidForCountryObj = this.countriesList.find((country) => country.dialCode == this.selectedPaidForCountryName);
      this.countryCurrency = countryCurrencyMap[this.selectedPaidForCountryName] || 'VND';
      this.registerForm.patchValue({
        paidForCountryName: this.selectedPaidForCountryName
      });
      this.registerForm.get('paidForMobileNumber')?.clearValidators();
      switch (this.selectedPaidForCountryObj && this.selectedPaidForCountryObj.name) {
        case 'Spain':
          this.paidForMinimunNumber = '9';
          this.paidForMaximumNumber = '9';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(9), // Minimum length of 9 digits
            Validators.maxLength(9)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
        case 'Indonesia':
          this.paidForMinimunNumber = '5';
          this.paidForMaximumNumber = '10';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(5), // Minimum length of 9 digits
            Validators.maxLength(10)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
        case 'Nigeria':
        case 'Vietnam':
          this.paidForMinimunNumber = '7';
          this.paidForMaximumNumber = '10';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(7), // Minimum length of 9 digits
            Validators.maxLength(10)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
        case 'Malaysia':
          this.paidForMinimunNumber = '7';
          this.paidForMaximumNumber = '9';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(7), // Minimum length of 9 digits
            Validators.maxLength(9)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
        case 'Australia':
          this.paidForMinimunNumber = '5';
          this.paidForMaximumNumber = '15';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(5), // Minimum length of 9 digits
            Validators.maxLength(15)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
        case 'Ecuador':
          this.paidForMinimunNumber = '8';
          this.paidForMaximumNumber = '8';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(8), // Minimum length of 9 digits
            Validators.maxLength(8)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
        case 'Saudi Arabia':
          this.paidForMinimunNumber = '8';
          this.paidForMaximumNumber = '9';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(8), // Minimum length of 9 digits
            Validators.maxLength(9)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
        default:
          this.paidForMinimunNumber = '10';
          this.paidForMaximumNumber = '10';
          this.registerForm.get('paidForMobileNumber')?.setValidators([
            Validators.required,
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(10), // Minimum length of 9 digits
            Validators.maxLength(10)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidForMobileNumber')?.updateValueAndValidity();
          break;
      }
    }
  }

  /**
   * @method
   * Description:
   * This method will be called when user changes the country selection in paid by field and the purpose of this method is that based on the country selected i am updating the
   * mobile number validation check.
   */
  public paidBycountrySelected(): void {
    if (this.selectedPaidByCountryName) {
      this.selectedPaidByCountryObj = this.countriesList.find((country) => country.dialCode == this.selectedPaidByCountryName);
      this.registerForm.patchValue({
        paidByCountryName: this.selectedPaidByCountryName
      });
      this.registerForm.get('paidByMobileNumber')?.clearValidators();
      switch (this.selectedPaidByCountryObj && this.selectedPaidByCountryObj.name) {
        case 'Spain':
          this.paidByMinimunNumber = '9';
          this.paidByMaximumNumber = '9';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(9), // Minimum length of 9 digits
            Validators.maxLength(9)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
        case 'Indonesia':
          this.paidByMinimunNumber = '5';
          this.paidByMaximumNumber = '10';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(5), // Minimum length of 9 digits
            Validators.maxLength(10)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
        case 'Nigeria':
          this.paidByMinimunNumber = '7';
          this.paidByMaximumNumber = '10';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(7), // Minimum length of 9 digits
            Validators.maxLength(10)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
        case 'Malaysia':
          this.paidByMinimunNumber = '7';
          this.paidByMaximumNumber = '9';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(7), // Minimum length of 9 digits
            Validators.maxLength(9)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
        case 'Australia':
          this.paidByMinimunNumber = '5';
          this.paidByMaximumNumber = '15';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(5), // Minimum length of 9 digits
            Validators.maxLength(15)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
        case 'Ecuador':
          this.paidByMinimunNumber = '8';
          this.paidByMaximumNumber = '8';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(8), // Minimum length of 9 digits
            Validators.maxLength(8)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
        case 'Saudi Arabia':
          this.paidByMinimunNumber = '8';
          this.paidByMaximumNumber = '9';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(8), // Minimum length of 9 digits
            Validators.maxLength(9)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
        default:
          this.paidByMinimunNumber = '10';
          this.paidByMaximumNumber = '10';
          this.registerForm.get('paidByMobileNumber')?.setValidators([
            Validators.pattern('^[0-9]*$'), // Ensures only numbers
            Validators.minLength(10), // Minimum length of 9 digits
            Validators.maxLength(10)  // Maximum length of 9 digits
          ]);
          this.registerForm.get('paidByMobileNumber')?.updateValueAndValidity();
          break;
      }
    }
  }

  /**
   * @method
   * @async
   * Description:
   * This method will be called when user clicks on the submit button and post clicking on it i am checking whether the susbcriber details are already exists or not based on this i am adding or updating a subbscriber
   */
  public async onFormSubmit() {
    if (!this.isPolicyAccepted) {
      this.toastr.error('Accept Terms & Conditions before proceeding');
      return false;
    }
    this.enableDisableSubmitButton = true;
    this.handleSubscriptionPlan(this.creditPolicy?.policyName);
  }

  /**
   * Handles subscription upgrade/downgrade logic based on business rules.
   * Rules:
   * 1. Only one active Premium or Priority Premium plan is allowed at a time per business.
   * 2. If a new plan is added, existing active plans (Premium or Priority Premium) must be expired first.
   * 3. If no active plan exists, simply add the new one.
   * 4. Handles cross-expiry cases (Premium → Priority Premium or Priority Premium → Premium).
   */
  public async handleSubscriptionPlan(policyName: string) {
    const businessId = this.businessEntity?.id;

    // Identify plan flags for Premium & Priority Premium
    const PREMIUM_FLAG = 'PBC';

    // Fetch active plans of both types for this business
    const activePremiumPlan = this.subscribersList.find(
      s => s.businessID === businessId && s.policyDetails?.policyFlag === PREMIUM_FLAG && s.isExpired === false
    );

    switch (policyName) {
      case 'Premium':
        await this.processPlanSwitch(activePremiumPlan, 'Premium');
        break;

      case 'BluEye Launch Plan':
        // Future logic can be added here if BluEye Launch Plan has similar rules
        this.subscribeBluEyePolicy();
        break;

      default:
        break;
    }
  }

  /**
   * Handles the switching logic between Premium & Priority Premium.
   * @param activeSamePlan - currently active plan of the same type (Premium → Premium or Priority Premium → Priority Premium)
   * @param activeOtherPlan - currently active plan of the opposite type (Premium vs Priority Premium)
   * @param policyFlag - policy flag identifier for the current plan type
   * @param planName - readable plan name (for logs/debugging)
   */
  private async processPlanSwitch(activeSamePlan: any, planName: string) {
    try {
      // Case 1: Same plan already active → expire & replace
      if (activeSamePlan) {
        await this.expireAndReplacePlan(activeSamePlan, planName);
        return;
      }

      // Case 3: No active plan → directly add new one
      this.addNewSubscriber();
    } catch (err) {
      this.toastr.error('Service failed, please try again');
      this.enableDisableSubmitButton = false;
    }
  }

  /**
   * Expires an active plan and replaces it with a new one.
   * @param existingPlan - the currently active plan that must be expired
   * @param newPolicyFlag - policy flag of the new plan being added
   * @param newPlanName - human-readable plan name
   */
  private async expireAndReplacePlan(existingPlan: any, newPlanName: string) {
    if (!this.isPolicyAccepted) {
      this.toastr.error('Accept Terms & Conditions before proceeding');
      return false;
    }

    existingPlan.isExpired = true;

    // Special case: Only Premium requires isBH check
    existingPlan.isBH = 0;

    const updateResponse = await this.creditsManagersService.updateOneByID(existingPlan.id, existingPlan);

    if (updateResponse?.updated) {
      // After expiring the old plan, add the new one
      this.addNewSubscriber(existingPlan);
    } else {
      this.toastr.error(`Failed to expire existing ${newPlanName} plan`);
      this.enableDisableSubmitButton = false;
    }
  }

  /**
   * @method
   * @async
   * @returns { Promise<void> } A promise that resolves when subscriber is added successfully, or an error occurs.
   * Description:
   * This method is used to add new subscriber by calling generic create method which is in the generic {@link Service} file.
   */
  public async addNewSubscriber(updatedCreditManager?: CreditsManagersModel) {
    if (!this.isPolicyAccepted) {
      this.toastr.error('Accept Terms & Conditions before proceeding');
      return false;
    }

    try {
      const countryCurrencyMap = {
        '+91': 'INR',
        '+61': 'AUD',
        '+593': 'USD',
        '+62': 'IDR',
        '+60': 'MYR',
        '+234': 'NGN',
        '+966': 'SAR',
        '+34': 'EUR'
      };
      /* Amount Paid date format adjusting */
      this.amountPaidDate = new Date(this.amountPaidDate);
      this.amountPaidDate = (this.amountPaidDate.getFullYear() > 0 ? this.amountPaidDate.getFullYear() : this.amountPaidDate.getFullYear() * -1) + '-' + (this.amountPaidDate.getMonth() + 1) + '-' + this.amountPaidDate.getDate();
      /* Subscription End Date format adjusting i.e based on policy duration the end date will be generated by adding policy duration days to the current day */
      // Get the current date
      let currentDate = new Date();
      // Add 30 days to the current date
      let futureDate = new Date(currentDate);
      futureDate.setDate(futureDate.getDate() + Number(this.creditPolicy.validityPeriod.duration));
      // Subtract one day from the future date
      futureDate.setDate(futureDate.getDate() - 1);
      // Format the future date as needed (optional)
      let subscriptionEndDate = futureDate.toISOString();
      const days = Number(this.creditPolicy.validityPeriod.duration) - 1;
      /* Credits Manager Request Body To add subscriber */
      this.subscriberSubscriptionsDuration = {
        period: String(days),
        unit: this.creditPolicy.validityPeriod.unit
      }
      this.subscriberPolicyDetails = {
        id: this.creditPolicy.id,
        name: this.creditPolicy.policyName,
        policyFlag: this.creditPolicy.policyName == 'Trial' ? 'TBC' : 'PBC'
      }
      this.subscriberPaymentDetails = {
        amount: Number(this.paidAmount),
        currency: countryCurrencyMap[this.selectedPaidForCountryName] || 'VND',
        paidBy: this.selectedPaidByCountryName + '-' + (this.paidByMobileNumber != null ? this.paidByMobileNumber : ''),
        paidFor: this.selectedPaidForCountryName + '-' + this.paidForMobileNumber,
        paidDate: moment(new Date()).format('YYYY-MM-DD').toString(),
        paymentMode: this.selectedPaymentMode,
        referenceID: this.referenceID
      }
      this.creditManager.termsAccepted = this.personEntity[0].businessID.agreedBCPolicyTerms;
      this.creditManager.creditsIssued = this.creditPolicy.appliedCredits;
      this.creditManager.creditsUsed = '0';
      this.creditManager.priorityPostingsIssued = this.creditPolicy.appliedPriorityPostings;
      this.creditManager.priorityPostingsUsed = '0';
      this.creditManager.durationLeft = this.subscriberSubscriptionsDuration
      this.creditManager.isExpired = false;
      this.creditManager.personID = this.personEntity[0].id;
      this.creditManager.businessID = this.businessEntity.id;
      this.creditManager.creditPolicyID = this.creditPolicy.id
      this.creditManager.policyDetails = this.subscriberPolicyDetails;
      this.creditManager.businessName = this.businessEntity.businessName;
      this.creditManager.personName = this.personEntity[0].firstName + ' ' + this.personEntity[0].lastName;
      this.creditManager.subscriptionStartDate = moment(new Date()).format('YYYY-MM-DD').toString();;
      this.creditManager.subscriptionEndDate = subscriptionEndDate;
      this.creditManager.paymentDetails = this.subscriberPaymentDetails;
      this.creditManager.createdBy = localStorage.getItem('loginPersonId');
      this.creditManager.updatedBy = localStorage.getItem('loginPersonId');
      this.creditManager.isBH = 0;
      // Submit Button disable True
      this.enableDisableSubmitButton = true;
      const response: any = await this.creditsManagersService.create(this.creditManager);
      if (response && response.length > 0) {
        const updatedResponse = response.map((data) => {
          data.duration = data.durationLeft.period != null ? data.durationLeft.period : 0;
          return data;
        });
        this.subscribersList.unshift(updatedResponse[0]);
        this.businessContacts.unshift(updatedResponse[0]);
        this.filteredBusinessContacts.unshift(updatedResponse[0]);
        if (updatedCreditManager) {
          const originalArrayDataIndex = this.subscribersList.findIndex((subscriber) => subscriber.id === updatedCreditManager.id);
          if (originalArrayDataIndex != -1) {
            this.subscribersList[originalArrayDataIndex] = updatedCreditManager;
            this.subscribersList = this.subscribersList.filter((element, index) => this.subscribersList.findIndex(Object => Object.id === element.id) === index);
          }
          const filteredArrayDataIndex = this.filteredBusinessContacts.findIndex((subscriber) => subscriber.id === updatedCreditManager.id);
          if (filteredArrayDataIndex != -1) {
            this.filteredBusinessContacts[filteredArrayDataIndex] = updatedCreditManager;
            this.filteredBusinessContacts = this.filteredBusinessContacts.filter((element, index) => this.filteredBusinessContacts.findIndex(Object => Object.id === element.id) === index);
          }
        } else {
          this.subscribersList = this.subscribersList.filter((element, index) => this.subscribersList.findIndex(Object => Object.id === element.id) === index);
          this.filteredBusinessContacts = this.filteredBusinessContacts.filter((element, index) => this.filteredBusinessContacts.findIndex(Object => Object.id === element.id) === index);
        }
        this.businessContactsCurrentPageNum = 1;
        this.businessContactsNoofItemsPerPage = 6;
        this.bluEyeSubscribersCurrentPageNum = 1;
        this.bluEyeSubscribersNoofItemsPerPage = 6;
        this.toastr.success('Subscriber added sucessfully');
        this.switchPolicyTypeData('businessContacts');
        this.onFormClose();
      } else {
        this.toastr.error('Failed to add new subscriber, Please try again');
        this.enableDisableSubmitButton = false;
      }
    } catch (error: any) {
      this.toastr.error(error.error?.message || error)
      this.enableDisableSubmitButton = false;
    }
  }

  /**
   * @method
   * @async
   * @returns { Promise<void> } A promise that resolves when subscriber is updated successfully, or an error occurs.
   * Description:
   * This method is used to update the existing subscriber by calling generic updateOneById method which is in the
   * generic {@link Service} file.
   */
  public async updateExistingSubscriber() {
    if (!this.isPolicyAccepted) {
      this.toastr.error('Accept Terms & Conditions before proceeding');
      return false;
    }
    if (this.creditPolicy.policyName == 'BluEye Launch Plan') {
      this.subscribeBluEyePolicy()
    } else {
      try {
        this.enableDisableSubmitButton = true;
        const countryCurrencyMap = {
          '+91': 'INR',
          '+61': 'AUD',
          '+593': 'USD',
          '+62': 'IDR',
          '+60': 'MYR',
          '+234': 'NGN',
          '+966': 'SAR',
          '+34': 'EUR'
        };
        /* Amount Paid date format adjusting */
        this.amountPaidDate = new Date(this.amountPaidDate);
        this.amountPaidDate = (this.amountPaidDate.getFullYear() > 0 ? this.amountPaidDate.getFullYear() : this.amountPaidDate.getFullYear() * -1) + '-' + (this.amountPaidDate.getMonth() + 1) + '-' + this.amountPaidDate.getDate();
        /* Subscription End Date format adjusting i.e based on policy duration the end date will be generated by adding policy duration days to the current day */
        // Get the current date
        let currentDate = new Date();
        // Add 30 days to the current date
        let futureDate = new Date(currentDate);
        futureDate.setDate(futureDate.getDate() + Number(this.creditPolicy.validityPeriod.duration));
        // Subtract one day from the future date
        futureDate.setDate(futureDate.getDate() - 1);
        // Format the future date as needed (optional)
        let subscriptionEndDate = futureDate.toISOString();
        /* Credits Manager Request Body To update existing subscriber with new details */
        this.subscriberSubscriptionsDuration = {
          period: this.creditManager?.durationLeft?.period,
          unit: this.creditManager?.durationLeft?.unit
        }
        this.subscriberPolicyDetails = {
          id: this.creditPolicy.id,
          name: this.creditPolicy.policyName,
          policyFlag: this.creditPolicy.policyName == 'Trial' ? 'TBC' : 'PBC'
        }
        this.subscriberPaymentDetails = {
          amount: Number(this.paidAmount),
          currency: countryCurrencyMap[this.selectedPaidForCountryName] || 'VND',
          paidBy: this.selectedPaidByCountryName + '-' + (this.paidByMobileNumber != null ? this.paidByMobileNumber : ''),
          paidFor: this.selectedPaidForCountryName + '-' + this.paidForMobileNumber,
          paidDate: moment(this.creditManager.subscriptionStartDate).format('YYYY-MM-DD').toString(),
          paymentMode: this.selectedPaymentMode,
          referenceID: this.referenceID
        }
        this.creditManager.creditsIssued = this.creditManager.creditsIssued;
        this.creditManager.creditsUsed = this.creditManager.creditsUsed;
        this.creditManager.priorityPostingsIssued = this.creditManager.priorityPostingsIssued;
        this.creditManager.priorityPostingsUsed = this.creditManager.priorityPostingsUsed;
        this.creditManager.durationLeft = this.subscriberSubscriptionsDuration
        this.creditManager.isExpired = false;
        this.creditManager.personID = this.creditManager.personID;
        this.creditManager.creditPolicyID = this.creditPolicy.id
        this.creditManager.policyDetails = this.subscriberPolicyDetails;
        this.creditManager.businessID = this.creditManager.businessID;
        this.creditManager.businessName = this.businessName;
        this.creditManager.personName = this.personName;
        this.creditManager.subscriptionStartDate = moment(new Date()).format('YYYY-MM-DD').toString();
        this.creditManager.subscriptionEndDate = subscriptionEndDate;
        this.creditManager.paymentDetails = this.subscriberPaymentDetails;
        this.creditManager.createdBy = localStorage.getItem('loginPersonId');
        this.creditManager.updatedBy = localStorage.getItem('loginPersonId');
        this.creditManager.isBH = 0;
        // Update Button Disable True
        const subscriberDetailsUpdated = await this.creditsManagersService.updateOneByID(this.creditManager.id, this.creditManager);
        if (subscriberDetailsUpdated.updated) {
          const originalArrayDataIndex = this.subscribersList.findIndex((subscriber) => subscriber.id === this.creditManager.id);
          if (originalArrayDataIndex != -1) {
            this.subscribersList[originalArrayDataIndex] = this.creditManager;
            this.subscribersList[originalArrayDataIndex] = this.subscribersList[originalArrayDataIndex] ?? {};
            this.subscribersList[originalArrayDataIndex].duration =
              this.subscribersList[originalArrayDataIndex]?.durationLeft?.period ?? 0;
          }
          const filteredArrayDataIndex = this.filteredBusinessContacts.findIndex((subscriber) => subscriber.id === this.creditManager.id);
          if (filteredArrayDataIndex != -1) {
            this.filteredBusinessContacts[filteredArrayDataIndex] = this.creditManager;
            this.filteredBusinessContacts[filteredArrayDataIndex] = this.filteredBusinessContacts[filteredArrayDataIndex] ?? {};
            this.filteredBusinessContacts[filteredArrayDataIndex].duration = this.filteredBusinessContacts[filteredArrayDataIndex]?.durationLeft?.period ?? 0;
          }
          this.toastr.success('Subscriber updated sucessfully');
          this.ngOnInit();
          this.switchPolicyTypeData('businessContacts');
          this.onFormClose();
        } else {
          this.toastr.error('Failed to update the subscriber, Please try again');
          this.enableDisableSubmitButton = false;
        }
      } catch (error: any) {
        this.toastr.error(error.error?.message || error)
        this.enableDisableSubmitButton = false;
      }
    }
  }

  /**
   * @method
   * @param { string } creditManager - This param indicates the creditsManager model
   * Description:
   * This method will be called when user clicks on the edit icon for each subscriber and binds that data to the creditsManager
   * model and displays it in the subscriber form.
   */
  public existingSubscriberPreview(creditManager: CreditsManagersModel) {
    this.isPopupOpen = false;
    this.showForm = true;
    this.updateButton = true;
    this.submitButton = false;
    this.enableDisableSubmitButton = false;
    this.creditManager = new CreditsManagersModel();
    this.creditManager = creditManager;
    this.selectedPaidForCountryName = creditManager.paymentDetails.paidFor?.split('-')[0] || '+91';
    this.selectedPaidByCountryName = creditManager.paymentDetails.paidBy?.split('-')[0] || '+91';
    this.policyId = creditManager.policyDetails.id;
    if (this.policyId) {
      this.getCreditPolicy();
    }
    this.paidForcountrySelected();
    this.policyTypeName = this.creditPolicy.creditType;
    this.paidForMobileNumber = creditManager.paymentDetails.paidFor?.split('-')[1];
    this.paidByMobileNumber = creditManager.paymentDetails.paidBy?.split('-')[1];
    this.paidAmount = creditManager.paymentDetails.amount;
    const paymentObject = this.paymentOptions.find((paymentOption) => paymentOption.value == creditManager.paymentDetails.paymentMode);
    this.referenceID = creditManager.paymentDetails.referenceID;
    if (this.policyTypeName) {
      this.getCreditPoliciesByPolicyType();
    }
    this.businessName = this.creditManager.businessName;
    this.personName = this.creditManager.personName;
    this.termsAccepted = false;
    this.isPolicyAccepted = false;
    this.amountPaidDate = (moment(new Date()).format('DD-MMM-YYYY')).toString();
    this.registerForm.patchValue({
      creditPolicyType: this.policyTypeName,
      creditPolicyName: creditManager.policyDetails.id,
      paidForCountryName: creditManager.paymentDetails.paidFor?.split('-')[0] || '+91',
      paidForMobileNumber: this.paidForMobileNumber,
      paidByCountryName: creditManager.paymentDetails.paidBy?.split('-')[0] || '+91',
      paidByMobileNumber: this.paidByMobileNumber,
      paidAmount: this.paidAmount,
      referenceid: this.referenceID,
      termsAccepted: false
    });
    if (paymentObject) {
      this.togglePaymentOption(paymentObject);
    }
    this.paidBycountrySelected();
  }

  /**
   * @method
   * @async
   * @param { string } subscriberId - This param indicates the subscriber id
   * Description:
   * This method will be called when user clicks on the subscriber in the subscribers list to display their usage tracker details
   */
  public async getSubscriberUsageTracker(subscriberId: string) {
    try {
      this.subscriberUsageTrackerService.cancelOnGoingHttpRequests();
      this.currentTrackerSubscriberId = subscriberId;
      this.trackerOffset = 0;
      this.isTrackerLoading = false;
      this.isTrackerEndOfData = false;
      this.trackerListLoader = false;
      this.usageTrackersearch = '';
      this.isPopupOpen = true;
      this.popupLoader = true;
      this.subscriberUsageTrackerView = [];
      this.businessContactsTrackerView = [];
      this.filteredSubscriberUsageTrackerViews = [];
      this.BlueEyeSubscribersTrackerView = [];
      this.filteredBlueEyeSubscribersTrackerView = [];

      if (this.isBusinessContactsTabActive) {
        this.switchTrackerViewTabs('businessContacts');
      } else {
        this.switchTrackerViewTabs('BluEye');
      }

      await this.fetchTrackerBatch();
    } catch (error: any) {
      this.toastr.error(error.error?.message || error);
      this.popupLoader = false;
    }
  }

  /**
   * Fetches the next batch of tracker records using offset pagination.
   */
  public async fetchTrackerBatch(): Promise<void> {
    if (this.isTrackerLoading || this.isTrackerEndOfData || !this.currentTrackerSubscriberId) {
      return;
    }

    const subscriberId = this.currentTrackerSubscriberId;
    const offset = this.trackerOffset;
    const isFirstBatch = offset === 0;

    this.isTrackerLoading = true;
    if (isFirstBatch) {
      this.popupLoader = true;
    } else {
      this.trackerListLoader = true;
    }

    try {
      const response = await this.subscriberUsageTrackerService.getSubscriberUsageTrackerById(
        subscriberId,
        offset,
        this.trackerPageSize
      );

      if (this.currentTrackerSubscriberId !== subscriberId) {
        return;
      }

      const records = response || [];

      // Avoid duplicate records using stable id identifier if available
      const existingIds = new Set(
        (this.subscriberUsageTrackerView || [])
          .map((item: CreditUsageTrackerModel) => item.id)
          .filter((id: string) => !!id)
      );
      const newUniqueRecords = records.filter(
        (item: CreditUsageTrackerModel) => !item.id || !existingIds.has(item.id)
      );

      this.subscriberUsageTrackerView = [
        ...(this.subscriberUsageTrackerView || []),
        ...newUniqueRecords
      ];

      if (!this.isBluEyeSubscribersTabActive) {
        const newBusinessContacts = newUniqueRecords.filter(
          (item: any) => !item.hasOwnProperty('seedPosting')
        );
        this.businessContactsTrackerView = [
          ...(this.businessContactsTrackerView || []),
          ...newBusinessContacts
        ];
        if (this.usageTrackersearch) {
          this.onUsageTrackerSearch();
        } else {
          this.filteredSubscriberUsageTrackerViews = this.businessContactsTrackerView;
        }
      } else {
        this.BlueEyeSubscribersTrackerView = [
          ...(this.BlueEyeSubscribersTrackerView || []),
          ...newUniqueRecords
        ];
        if (this.usageTrackersearch) {
          this.onUsageTrackerSearch();
        } else {
          this.filteredBlueEyeSubscribersTrackerView = this.BlueEyeSubscribersTrackerView;
        }
      }

      // Increment offset by 20 only after a successful request
      this.trackerOffset += this.trackerPageSize;

      // Stop condition: Stop pagination when the API response contains fewer records than pageSize (20)
      if (records.length < this.trackerPageSize) {
        this.isTrackerEndOfData = true;
      }
    } catch (error: any) {
      if (this.currentTrackerSubscriberId === subscriberId) {
        this.toastr.error(error.error?.message || error);
      }
    } finally {
      if (this.currentTrackerSubscriberId === subscriberId) {
        this.isTrackerLoading = false;
        this.popupLoader = false;
        this.trackerListLoader = false;
      }
    }
  }

  /**
   * Scroll handler for Credits Usage Tracker tables to trigger infinite scroll.
   * Fetches the next batch when user scrolls near the bottom of the container.
   */
  public onTrackerScroll(event: Event): void {
    const element = event.target as HTMLElement;
    if (!element) return;
    clearTimeout(this.trackerScrollTimeout);
    this.trackerScrollTimeout = setTimeout(() => {
      const threshold = 100;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + threshold;
      if (atBottom && !this.isTrackerLoading && !this.isTrackerEndOfData) {
        this.fetchTrackerBatch();
      }
    }, 50);
  }

  /**
   * @method
   * Description:
   * This method will be called when user clicks on the cross mark in the usage tracker view to close the tracker view popup and disable the popup loader to false
   */
  public closePopup() {
    this.isPopupOpen = false;
    this.popupLoader = false;
    this.trackerListLoader = false;
    this.isTrackerLoading = false;
    this.currentTrackerSubscriberId = '';
    clearTimeout(this.trackerScrollTimeout);
    this.subscriberUsageTrackerService.cancelOnGoingHttpRequests();
  }

  /**
   * @method
   * Description:
   * This method will be called on post component initialization, adding or updating a subcriber and opening or closing of the subscriber form and the puroose
   * of this method is to create an instance of the credit manager, SubscriberSubscriptionDuration, SubscriberPaymentDetails and SubscriberPolicyDetails required for subscriber add and update.
   */
  public modelsInstancesCreation() {
    this.creditManager = new CreditsManagersModel();
    this.subscriberSubscriptionsDuration = new SubscriberSubscriptionDuration();
    this.subscriberPaymentDetails = new SubscriberPaymentDetails();
    this.subscriberPolicyDetails = new SubscriberPolicyDetails();
  }

  /**
   * @method
   * Description:
   * This method will be called when user types in the search field or select the business type in the business type selection field and vice versa to apply filters on the subscribers list.
   */
  public onFiltersApplied() {
    this.isFiltering = true;
    if (this.isBusinessContactsTabActive) {
      this.filteredBusinessContacts = [];
    } else if (this.isBluEyeSubscribersTabActive) {
      this.filteredBluEyeSubscribers = [];
    }
    const value = this.search && this.search.replace(/[-_ :.]/g, '').toLowerCase();
    if (this.search != '') {
      if (((this.statusFilter) && this.isBusinessContactsTabActive) || (this.statusFilter && (this.isBluEyeSubscribersTabActive))) {
        this.applySearchWithFilterType(value);
      } else {
        this.applySearchFilter(value);
      }
    } else {
      if (((this.statusFilter) && this.isBusinessContactsTabActive) || (this.statusFilter && (this.isBluEyeSubscribersTabActive))) {
        this.applySearchWithFilterType(value);
      } else {
        this.isFiltering = false;
        this.initializeBatchLoader();
        this.batchLoader.reset();
        this.batchLoader.loadNextBatch(true);
      }
    }
  }

  /**
   * @method
   * Description:
   * This method will be called when user searches the specific data in the search field to filter the usage trackers list based upon the search.
   */
  public onUsageTrackerSearch() {
    const value = this.usageTrackersearch && this.usageTrackersearch.replace(/[-_ :.]/g, '').toLowerCase();
    if (this.businessContactViewTabActive) {
      this.filteredSubscriberUsageTrackerViews = [];
      this.filteredSubscriberUsageTrackerViews = this.businessContactsTrackerView.filter((subscriber: any) =>
        ['businessName', 'personName', 'mobileNumber.phoneNumber'].some(property => {
          const nestedPropertyValue = property.split('.').reduce((acc, current) => acc && acc[current], subscriber);
          return nestedPropertyValue && nestedPropertyValue.replace(/[-_ :.]/g, '').toLowerCase().includes(value);
        })
      );
    }
  }

  /**
   * @method
   * @param {string} searchValue - This param is used to get the search value entered by the user manually.
   * Description:
   * This method will be called when user searches the specific data in the search field to filter the subscribers list based upon the search.
   */
  private applySearchFilter(searchValue: string) {
    if (this.isBusinessContactsTabActive) {
      this.filteredBusinessContacts = this.businessContacts.filter((subscriber: any) =>
        ['businessName', 'personName', 'paymentDetails.paidFor'].some(property => {
          const nestedPropertyValue = property.split('.').reduce((acc, current) => acc && acc[current], subscriber);
          return nestedPropertyValue && nestedPropertyValue.replace(/[-_ :.]/g, '').toLowerCase().includes(searchValue);
        })
      );
    } else {
      this.filteredBluEyeSubscribers = this.bluEyeSubscribers.filter((subscriber: any) =>
        ['businessName', 'personName', 'paymentDetails.paidFor'].some(property => {
          const nestedPropertyValue = property.split('.').reduce((acc, current) => acc && acc[current], subscriber);
          return nestedPropertyValue && nestedPropertyValue.replace(/[-_ :.]/g, '').toLowerCase().includes(searchValue);
        })
      );
    }
  }

  /**
   * @method
   * @param {string} searchValue - This param is used to get the search value entered by the user manually.
   * Description:
   * This method will be called when user searches the specific data and then apply the business type filter upon the filtered data to filter
   * the specific data in two way connection.
   */
  private applySearchWithFilterType(searchValue: string) {
    if (this.isBusinessContactsTabActive) {
      this.filteredBusinessContacts = this.businessContacts.filter((subscriber: any) => {
        let includeConditions = true; // Initialize shouldKeep as true
        if (this.statusFilter && String(subscriber.isExpired) != this.status) {
          includeConditions = false;
        }
        const includesSearch = ['businessName', 'personName', 'paymentDetails.paidFor'].some(property => {
          const nestedPropertyValue = property.split('.').reduce((acc, current) => acc && acc[current], subscriber);
          return nestedPropertyValue && nestedPropertyValue.replace(/[-_ :.]/g, '').toLowerCase().includes(searchValue);
        })
        return this.search != '' ? includeConditions && includesSearch : includeConditions;
      });
    } else {
      this.filteredBluEyeSubscribers = this.bluEyeSubscribers
        .map((subscriber: any) => {
          const filteredDevices = subscriber.devicesDetails?.filter((device: any) => {
            // If no status filter is applied, return all devices
            if (!this.statusFilter || !this.status) return true;

            // Compare based on status
            if (this.status === 'false') {
              return device.isActive === true;  // Show active devices
            } else if (this.status === 'true') {
              return device.isActive === false; // Show inactive devices
            }
            return true;
          });

          if (filteredDevices && filteredDevices.length > 0) {
            return {
              ...subscriber,
              devicesDetails: filteredDevices,
            };
          }
          return null;
        })
        .filter((subscriber) => subscriber !== null)
        .filter((subscriber) => {
          const searchValue = this.search?.replace(/[-_ :.]/g, '').toLowerCase() || '';
          const includesSearch = ['businessName', 'personName', 'paymentDetails.paidFor'].some(property => {
            const nestedPropertyValue = property.split('.').reduce((acc, current) => acc && acc[current], subscriber);
            return nestedPropertyValue && nestedPropertyValue.toString().replace(/[-_ :.]/g, '').toLowerCase().includes(searchValue);
          });
          return this.search ? includesSearch : true;
        });
    }
  }


  /**
   * @method
   * @param {string} type - The type of sorting (e.g asc or desc order).
   * Description:
   * This method Sorts the credits used, credits issue and days left column data in the Subscribers list.
   */
  public businessContactsColumnSorting(type: string): void {
    let orderByField: string;
    let asc: boolean;
    switch (type) {
      case 'creditsIssued':
        orderByField = 'creditsIssued';
        asc = this.toggleSortingAndGetOrder('sortDispatchedDate');
        break;
      case 'creditsUsed':
        orderByField = 'creditsUsed';
        asc = this.toggleSortingAndGetOrder('sortBookedForCustomerName');
        break;
      case 'durationLeft':
        orderByField = 'duration';
        asc = this.toggleSortingAndGetOrder('sortDispatchedLocation');
        break;
      default:
        return;
    }
    const orderByVal = asc ? 'asc' : 'desc';
    this.filteredBusinessContacts = _.orderBy(this.filteredBusinessContacts, [orderByField], [orderByVal]);
    // Reset other sorting flags
    this.sortCreditsIssued = type === 'creditsIssued' ? asc : false;
    this.sortCreditsused = type === 'creditsUsed' ? asc : false;
    this.sortDurationleftDays = type === 'durationLeft' ? asc : false;
  }

  /**
   * @method
   * @param {string} flagName - Sorted column identification flag name.
   * @returns { string } It returns the current order type of that flag name
   * Description:
   * The purpose of this method is to get the current sorting order of the selected sorted column by identifying with the flag name.
   */
  private toggleSortingAndGetOrder(flagName: string): boolean {
    const currentOrder = this[flagName];
    this[flagName] = !currentOrder;
    return this[flagName];
  }

  /**
   * @method
   * Description:
   * Shortcut to access form controls for convenient validation.
   */
  public get f() {
    return this.registerForm.controls;
  }


  /**
   * @method
   * Description:
   * This method will be called on form close by clicking on the cross mark or cancel button in Form and the pourpose of
   * this method is to initialize all the necessary variables required for form submission along with some common validation variables.
   */
  public onFormClose(): void {
    this.registerForm.reset();
    this.showForm = false;
    this.submitButton = false;
    this.updateButton = false;
    this.enableDisableSubmitButton = false;
    this.policyTypeName = '';
    this.policyId = '';
    this.finalmatchedDevice = [];
    this.matchedDevices = [];
    this.matchedInActiveDevices = [];
    this.sameMatchingDevice = [];
    this.deviceMessages = [];
    this.paidForMobileNumber = '';
    this.paidByMobileNumber = '';
    this.businessName = '';
    this.personName = '';
    this.paidAmount = '';
    this.selectedPaymentMode = '';
    this.referenceID = '';
    this.amountPaidDate = (moment(new Date()).format('DD-MMM-YYYY')).toString();
    this.creditPolicy = new CreditsPolicyModel();
    this.startDate = undefined;
    this.endDate = undefined;
    this.modelsInstancesCreation();
    this.paymentOptions.forEach((paymentOption: any) => paymentOption.isPaymentSelected = false);
    this.setupFormSubscription();
    this.selectedPaidByCountryName = '+91';
    this.selectedPaidForCountryName = '+91';
    this.registerForm.patchValue({
      paidByCountryName: '+91'
    });
    this.registerForm.patchValue({
      paidForCountryName: '+91'
    });
    if (this.selectedPaidByCountryName) {
      this.paidBycountrySelected();
    }
    if (this.selectedPaidForCountryName) {
      this.paidForcountrySelected();
    }
    this.imageFile = undefined;
    this.isFileSelected = false;
    this.fileName = undefined;
    this.filePath = undefined;
    this.selectedbase64file = undefined;
    $('#imageUpload').val('');
  }

  public isFileSelected: boolean;
  selectedbase64file: SafeResourceUrl | null = null;
  public imageFile: File | any;
  public fileName: string;
  public filePath: string;

  public fileupload(event: any): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 2097152) {
          this.toastr.error('Image size should not exceed 2MB');
          $('#imageUpload').val('');
        } else {
          this.imageFile = file;
          this.isFileSelected = true;
          this.fileName = file.name;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const dataUrl = reader.result as string;
            this.selectedbase64file = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
          };
          this.uploadFileToS3();
          reader.onerror = () => {
          };
        }
      } else {
        this.isFileSelected = false;
      }
    }
  }

  uploadFileToS3() {
    if (this.isFileSelected) {
      this.businessEntityService.uploadFileToS3Bucket(this.imageFile, this.businessEntity.businessName, 'Blueye', `${this.imageFile.name}`).subscribe(async (response) => {
        if (response) {
          this.fileName = this.imageFile.type.split('/')[1];
          this.filePath = Object.values(response)[0];
          this.downloadFile(this.filePath, this.fileName);
        }
      })
    }
  }

  downloadFile(filePath, fileType) {
    const file = this.businessEntityService.downloadFileFromS3Bucket(filePath, fileType);
    file.subscribe(fileBlob => {
      const readFile = new FileReader();
      readFile.readAsDataURL(fileBlob);
      readFile.onload = () => {
        this.selectedbase64file = readFile.result;
      }
    });
  }

  editDownloadFile(filePath: string, fileType: string) {
    this.businessEntityService.downloadFileFromS3Bucket(filePath, fileType).subscribe(fileBlob => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64data = reader.result as string;
        this.selectedbase64file = base64data;
      };
      reader.readAsDataURL(fileBlob);
    });
  }


  public remove(): void {
    /**
     * Asks for user confirmation before proceeding with the image removal.
     * @type {boolean}
     */
    const deleteimage: boolean = confirm('Are you sure you want to delete these image?');
    if (deleteimage) {
      this.imageFile = undefined;
      this.isFileSelected = false;
      this.fileName = undefined;
      this.filePath = undefined;
      this.selectedbase64file = undefined;
      $('#imageUpload').val('');
    }
  }

  trackByCardId(index: number, card: any): string {
    return card._id || index;
  }

  showInvoiceModal: boolean = false;
  invoiceFiles: SafeResourceUrl[] = [];

  getInvoice(list: any): void {
    this.showInvoiceModal = true;
    const receipts = list?.paymentDetails?.paymentReceipts || [];
    const validFiles = receipts.filter(path => path); // removes null/undefined
    if (validFiles.length === 0) {
      this.toastr.info('No invoice files found.');
      this.showInvoiceModal = false;
      return;
    }
    this.invoiceFiles = []; // clear previous ones
    validFiles.forEach((filePath: string) => {
      this.invoiceDownloadFile(filePath, 'pdf');
    });
    this.showInvoiceModal = true;
  }

  invoiceDownloadFile(filePath: string, fileType: string): void {
    this.businessEntityService.downloadFileFromS3Bucket(filePath, fileType).subscribe(fileBlob => {
      const reader = new FileReader();
      reader.readAsDataURL(fileBlob);
      reader.onload = () => {
        const base64 = reader.result as string;
        const pdfBase64 = 'data:application/pdf;base64,' + base64.split(',')[1];
        const trusted = this.sanitizer.bypassSecurityTrustResourceUrl(pdfBase64);
        this.invoiceFiles.push(trusted);
      };
    });
  }

  closeModal(): void {
    this.showAssignDeassignForm = false;
    this.showInvoiceModal = false;
    this.invoiceFiles = [];
  }

  deviceDetails: any;
  farmSiteId: any;
  policyDetails: any;
  async assignPu(list, device) {
    this.showAssignDeassignForm = true;
    this.deviceDetails = device;
    this.policyDetails = list;
    if (list && list.businessType == 'Farm') {
      if (this.deviceDetails && this.deviceDetails.farmSiteId) {
        this.farmSiteId = this.deviceDetails.farmSiteId;
      }
      console.log(3039, this.deviceDetails.farmSiteId)
      this.farmSites = await this.farmSiteService.getFarmeSitesByFarmId(list.businessID);
    }
  }

  closeFarmsiteDetails() {
    this.farmSites = [];
    this.farmSiteId = undefined;
  }

  async assignDevice() {
    let item
    if (this.policyDetails && this.policyDetails.businessType == 'Farm') {
      item = this.farmSites.find(siteName => siteName.id == this.farmSiteId);
    }
    console.log('item', item);
    let siteId = '0001';
    let input = {
      devicesDetails:[{
        isSelected: false,
        _id: this.deviceDetails._id,
      }],
      id: this.policyDetails.id,
      isDeepUpdate: true,
      updatedBy: localStorage.personID
    }
    if (this.policyDetails && this.policyDetails.businessType === 'Farm') {
      // For Farm type: add farmSiteId and farmSiteName
      input.devicesDetails[0]['farmSiteId'] = this.farmSiteId;
      input.devicesDetails[0]['farmSiteName'] = item.farmNameAtLocation;
    }
    // return
    await this.creditsManagersService.updateOneByID(this.policyDetails.id, input);
    this.toastr.success('Assigned successfully');
    this.showAssignDeassignForm = false;
    this.farmSiteId = undefined;
    this.ngOnInit();
    this.switchPolicyTypeData('blueEyePlan');
  }

  async deAssign() {
    let input = {
      devicesDetails:[{
        isSelected: false,
        _id: this.deviceDetails._id,
      }],
      id: this.policyDetails.id,
      isDeepUpdate: true,
      updatedBy: localStorage.personID
    }
    if (this.policyDetails && this.policyDetails.businessType === 'Farm') {
      // For Farm type: add farmSiteId and farmSiteName
      input.devicesDetails[0]['farmSiteId'] = null;
      input.devicesDetails[0]['farmSiteName'] = null;
    }
    // return
    await this.creditsManagersService.updateOneByID(this.policyDetails.id, input);
    this.toastr.success('De-Assigned successfully');
    this.showAssignDeassignForm = false;
    this.farmSiteId = undefined;
    this.ngOnInit();
    this.switchPolicyTypeData('blueEyePlan');
  }

  public get isPaymentModeInvalid(): boolean {
    return this.submitted && !this.paymentOptions?.some(p => p.isPaymentSelected);
  }

  get displayLocationHeader(): string {
    if (this.filteredBlueEyeSubscribersTrackerView?.length > 0) {
      const first = this.filteredBlueEyeSubscribersTrackerView[0]?.bluEyeTrack;
      return 'Farm Site';
    }
    return 'Location';
  }

  ngOnDestroy(): void {
    clearTimeout(this.scrollTimeout);
    clearTimeout(this.trackerScrollTimeout);
    this.subscriberUsageTrackerService.cancelOnGoingHttpRequests();
    this.batchLoader?.markAsDestroyed();
  }

}